// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Bookmark, Search, Download, Trash2, Edit3, X, Star, Phone, Globe,
//   ExternalLink, MapPin, ChevronLeft, ChevronRight, Calendar, Plus,
//   UserCheck, Mail, Send, ArrowRightLeft, MessageSquare, Check, Clock,
//   AlertTriangle, RefreshCw } from 'lucide-react';
// import api from '../utils/api';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// const STATUS_OPTS    = ['new','contacted','qualified','converted','lost'];
// const PRIORITY_OPTS  = ['low','medium','high','urgent'];
// const STATUS_COLORS  = { new:'badge-blue', contacted:'badge-gold', qualified:'badge-purple', converted:'badge-green', lost:'badge-red' };
// const PRIORITY_COLORS= { low:'badge-gray', medium:'badge-blue', high:'badge-gold', urgent:'badge-red' };

// const STATUSES = [
//   { value:'pending',     label:'Pending',     cls:'badge-gray'   },
//   { value:'in_progress', label:'In Progress', cls:'badge-blue'   },
//   { value:'contacted',   label:'Contacted',   cls:'badge-gold'   },
//   { value:'qualified',   label:'Qualified',   cls:'badge-purple' },
//   { value:'converted',   label:'Converted',   cls:'badge-green'  },
//   { value:'lost',        label:'Lost',        cls:'badge-red'    },
// ];
// const statusLabel = s => STATUSES.find(x=>x.value===s)?.label || STATUS_OPTS.find(x=>x===s) || s || '—';
// const statusBadge = s => STATUSES.find(x=>x.value===s)?.cls || STATUS_COLORS[s] || 'badge-gray';
// const priColor    = p => ({ urgent:'#ef4444', high:'#f97316', medium:'#f59e0b', low:'#94a3b8' }[p] || '#94a3b8');
// const fmtDate     = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'}) : '—';
// const isOverdue   = d => d && new Date(d) < new Date();

// // ── Lead Detail Side Panel (from TeamPage) ────────────────────────────────
// function LeadPanel({ lead, isAssigned, onClose, onRefresh }) {
//   const { user }               = useAuth();
//   const [comments, setComments]= useState([]);
//   const [activity, setActivity]= useState([]);
//   const [newComment, setComment]= useState('');
//   const [posting, setPosting]  = useState(false);
//   const [tab, setTab]          = useState('details');
//   const [stLd, setStLd]        = useState(false);
//   const bottomRef              = useRef(null);

//   const savedLeadId = lead.saved_lead_id || lead.id;
//   const teamId      = lead.team_id || '';
//   const assignmentId = lead.assignment_id || lead.id;

//   const loadComments = useCallback(async () => {
//     if (!teamId) return;
//     try {
//       const [cr, ar] = await Promise.all([
//         api.get('/teams/comments', { params:{ savedLeadId, teamId } }),
//         api.get('/teams/activity',  { params:{ savedLeadId, teamId } }),
//       ]);
//       setComments(cr.data.comments||[]);
//       setActivity(ar.data.activity||[]);
//     } catch {}
//   }, [savedLeadId, teamId]);

//   useEffect(() => { loadComments(); }, [loadComments]);
//   useEffect(() => { if (tab==='comments') bottomRef.current?.scrollIntoView({ behavior:'smooth' }); }, [comments, tab]);

//   const changeStatus = async status => {
//     setStLd(true);
//     try {
//       if (isAssigned) {
//         await api.put(`/teams/assignments/${assignmentId}`, { status });
//       } else {
//         await api.put(`/leads/saved/${lead.id}`, { status });
//       }
//       toast.success(`Status → ${statusLabel(status)}`);
//       onRefresh();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
//     finally { setStLd(false); }
//   };

//   const postComment = async e => {
//     e.preventDefault();
//     if (!newComment.trim() || !teamId) return;
//     setPosting(true);
//     try {
//       const r = await api.post('/teams/comments', { savedLeadId, teamId, comment: newComment.trim() });
//       setComments(c => [...c, r.data.comment]);
//       setComment('');
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
//     finally { setPosting(false); }
//   };

//   const delComment = async id => {
//     try { await api.delete(`/teams/comments/${id}`); setComments(c => c.filter(x=>x.id!==id)); }
//     catch { toast.error('Failed'); }
//   };

//   return (
//     <>
//       <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:199 }} onClick={onClose}/>
//       <div style={{ position:'fixed', top:0, right:0, bottom:0, width:'min(480px,100vw)', background:'var(--surface)', borderLeft:'1px solid var(--border)', zIndex:200, display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,.2)', overflowY:'auto' }}>

//         {/* Header */}
//         <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'flex-start', gap:10, position:'sticky', top:0, background:'var(--surface)', zIndex:1 }}>
//           <div style={{ flex:1, minWidth:0 }}>
//             <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>{lead.name}</div>
//             <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
//               <span className={`badge ${statusBadge(lead.status)}`}><span className="badge-dot"/>{statusLabel(lead.status)}</span>
//               {lead.priority && <span style={{ fontSize:11.5, fontWeight:700, color:priColor(lead.priority) }}>● {lead.priority}</span>}
//               {lead.follow_up_date && <span style={{ fontSize:11.5, color:isOverdue(lead.follow_up_date)?'var(--red)':'var(--text3)' }}>📅 {fmtDate(lead.follow_up_date)}</span>}
//             </div>
//           </div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={15}/></button>
//         </div>

//         {/* Contact */}
//         <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)', display:'flex', flexDirection:'column', gap:6 }}>
//           {lead.phone   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Phone size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`tel:${lead.phone}`} style={{ color:'var(--text2)', textDecoration:'none' }}>{lead.phone}</a></div>}
//           {lead.email   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Mail size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`mailto:${lead.email}`} style={{ color:'var(--accent)', textDecoration:'none' }}>{lead.email}</a></div>}
//           {lead.website && <div style={{ display:'flex', gap:8, fontSize:13 }}><Globe size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{ color:'var(--accent)', textDecoration:'none', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a></div>}
//           {lead.address && <div style={{ display:'flex', gap:8, fontSize:12.5, color:'var(--text3)' }}><MapPin size={13} style={{ flexShrink:0, marginTop:1 }}/>{lead.address}</div>}
//           {/* Owner / assigned info */}
//           {lead.list_name && !isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>📋 List: <strong style={{ color:'var(--text)' }}>{lead.list_name}</strong></div>}
//           {lead.assigned_by_name && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👤 Assigned by: <strong style={{ color:'var(--text)' }}>{lead.assigned_by_name}</strong></div>}
//           {lead.team_name && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👥 Team: <strong style={{ color:'var(--text)' }}>{lead.team_name}</strong></div>}
//           {lead.rating && <div style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/><strong>{Number(lead.rating).toFixed(1)}</strong><span style={{ color:'var(--text3)', fontSize:12 }}>({lead.review_count||0} reviews)</span></div>}
//           {lead.lead_score > 0 && <div style={{ fontSize:12.5, color:'var(--text3)' }}>🎯 Lead Score: <strong style={{ color:'var(--text)' }}>{lead.lead_score}</strong></div>}
//         </div>

//         {/* Status change — all leads */}
//         <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)' }}>
//           <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>Update Status</div>
//           <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
//             {(isAssigned ? STATUSES : [
//               { value:'new',       label:'New',       cls:'badge-blue'   },
//               { value:'contacted', label:'Contacted', cls:'badge-gold'   },
//               { value:'qualified', label:'Qualified', cls:'badge-purple' },
//               { value:'converted', label:'Converted', cls:'badge-green'  },
//               { value:'lost',      label:'Lost',      cls:'badge-red'    },
//             ]).map(s => (
//               <button key={s.value} onClick={() => changeStatus(s.value)} disabled={stLd}
//                 className={`badge ${s.cls}`}
//                 style={{ cursor:'pointer', padding:'5px 11px', border:`2px solid ${(lead.status||'new')===s.value?'currentColor':'transparent'}`, fontSize:12, opacity:(lead.status||'new')===s.value?1:0.6, transition:'all .15s' }}>
//                 {(lead.status||'new')===s.value && <Check size={10}/>}{s.label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Tabs */}
//         <div style={{ display:'flex', borderBottom:'1px solid var(--border)', padding:'0 20px' }}>
//           {[['details','📋 Details'], ['comments',`💬 Comments (${comments.length})`], ...(teamId?[['activity','📋 Activity']]:[])]
//             .map(([v,l]) => (
//               <button key={v} onClick={() => { setTab(v); if(v==='comments'||v==='activity') loadComments(); }}
//                 style={{ padding:'10px 14px', border:'none', background:'none', fontWeight:tab===v?700:500, fontSize:13, color:tab===v?'var(--accent)':'var(--text3)', cursor:'pointer', borderBottom:tab===v?'2px solid var(--accent)':'2px solid transparent', marginBottom:-1 }}>
//                 {l}
//               </button>
//             ))
//           }
//         </div>

//         {/* Details tab */}
//         {tab==='details' && (
//           <div style={{ padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//             {lead.notes && (
//               <div style={{ background:'var(--bg3)', borderRadius:8, padding:'10px 14px', fontSize:13.5, color:'var(--text2)', lineHeight:1.6 }}>
//                 <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', marginBottom:6, textTransform:'uppercase', letterSpacing:.8 }}>Notes</div>
//                 {lead.notes}
//               </div>
//             )}
//             {lead.google_maps_url && (
//               <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-full" style={{ textDecoration:'none', justifyContent:'center' }}>
//                 <ExternalLink size={13}/> View on Map
//               </a>
//             )}
//           </div>
//         )}

//         {/* Comments tab */}
//         {tab==='comments' && (
//           <div style={{ flex:1, display:'flex', flexDirection:'column' }}>
//             {!teamId ? (
//               <div style={{ flex:1, padding:'32px 20px', textAlign:'center', color:'var(--text3)', fontSize:13 }}>
//                 <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
//                 <div>Comments are available for team-assigned leads only.</div>
//                 <div style={{ fontSize:12, marginTop:6 }}>Assign this lead to a team member to enable comments.</div>
//               </div>
//             ) : (
//               <>
//                 <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//                   {comments.length===0 && (
//                     <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
//                       <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
//                       <div>No comments yet</div>
//                     </div>
//                   )}
//                   {comments.map(c => (
//                     <div key={c.id} style={{ display:'flex', gap:10 }}>
//                       <div style={{ width:32, height:32, borderRadius:'50%', background:'linear-gradient(135deg,var(--accent),var(--accent2))', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:12, fontWeight:700, flexShrink:0 }}>
//                         {c.first_name?.[0]}{c.last_name?.[0]}
//                       </div>
//                       <div style={{ flex:1 }}>
//                         <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
//                           <span style={{ fontWeight:600, fontSize:13 }}>{c.first_name} {c.last_name}</span>
//                           <span style={{ fontSize:11, color:'var(--text3)' }}>{new Date(c.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</span>
//                           {c.user_id===user?.id && <button onClick={()=>delComment(c.id)} style={{ marginLeft:'auto', background:'none', border:'none', color:'var(--text3)', cursor:'pointer', padding:2, display:'flex', borderRadius:4 }}><Trash2 size={11}/></button>}
//                         </div>
//                         <div style={{ background:'var(--bg3)', borderRadius:'4px 12px 12px 12px', padding:'8px 12px', fontSize:13.5, lineHeight:1.5, wordBreak:'break-word' }}>{c.comment}</div>
//                       </div>
//                     </div>
//                   ))}
//                   <div ref={bottomRef}/>
//                 </div>
//                 <div style={{ padding:'12px 20px', borderTop:'1px solid var(--border)' }}>
//                   <form onSubmit={postComment} style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
//                     <textarea className="textarea" style={{ flex:1, minHeight:40, maxHeight:100, resize:'none', fontSize:13.5 }}
//                       placeholder="Add a comment… (Enter to send)"
//                       value={newComment} onChange={e=>setComment(e.target.value)}
//                       onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();postComment(e);} }}/>
//                     <button type="submit" className="btn btn-primary" style={{ padding:'8px 12px', flexShrink:0 }} disabled={posting||!newComment.trim()}>
//                       {posting?<div className="spinner spinner-sm"/>:<Send size={14}/>}
//                     </button>
//                   </form>
//                 </div>
//               </>
//             )}
//           </div>
//         )}

//         {/* Activity tab */}
//         {tab==='activity' && teamId && (
//           <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//             {activity.length===0 && (
//               <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
//                 <Clock size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/><div>No activity yet</div>
//               </div>
//             )}
//             {activity.map(a => (
//               <div key={a.id} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
//                 <div style={{ width:28, height:28, borderRadius:'50%', background:'var(--bg3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>
//                   {({assigned:'🎯',transferred:'↔️',status_changed:'🔄',comment_added:'💬'}[a.action]||'📋')}
//                 </div>
//                 <div style={{ flex:1 }}>
//                   <div style={{ fontSize:13, color:'var(--text2)', lineHeight:1.5 }}>
//                     <strong>{a.first_name} {a.last_name}</strong>{' '}
//                     {a.action==='assigned' && 'assigned this lead'}
//                     {a.action==='transferred' && 'transferred this lead'}
//                     {a.action==='status_changed' && <><span style={{ color:'var(--text3)' }}>changed status to </span><strong>{statusLabel(a.new_value)}</strong></>}
//                     {a.action==='comment_added' && 'added a comment'}
//                   </div>
//                   {a.note && a.action!=='comment_added' && <div style={{ fontSize:12, color:'var(--text3)', fontStyle:'italic', marginTop:2 }}>"{a.note}"</div>}
//                   <div style={{ fontSize:11, color:'var(--text3)', marginTop:3 }}>{new Date(a.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Edit Modal ────────────────────────────────────────────────────────────
// function EditModal({ lead, onClose, onSave }) {
//   const [form, setForm] = useState({
//     status: lead.status||'new', priority: lead.priority||'medium',
//     notes: lead.notes||'', listName: lead.list_name||'Default',
//     followUpDate: lead.follow_up_date?.split('T')[0]||''
//   });
//   const [saving, setSaving] = useState(false);
//   const save = async () => {
//     setSaving(true);
//     try { await onSave(lead.id, form); onClose(); }
//     catch { toast.error('Failed to save'); }
//     finally { setSaving(false); }
//   };
//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title">Edit Lead — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">CRM Status</label>
//               <select className="select" value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>
//                 {STATUS_OPTS.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
//               </select>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Priority</label>
//               <select className="select" value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))}>
//                 {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//               </select>
//             </div>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">List Name</label>
//               <input className="input" value={form.listName} onChange={e=>setForm(f=>({...f,listName:e.target.value}))} placeholder="Default"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Follow-up Date</label>
//               <input className="input" type="date" value={form.followUpDate} onChange={e=>setForm(f=>({...f,followUpDate:e.target.value}))}/>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Notes</label>
//             <textarea className="textarea" value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Add notes…"/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Add Lead Modal ────────────────────────────────────────────────────────
// function AddLeadModal({ onClose, onAdded }) {
//   const [form, setForm] = useState({
//     name:'', address:'', phone:'', email:'', website:'',
//     listName:'Default', priority:'medium', notes:''
//   });
//   const [saving, setSaving] = useState(false);
//   const [errors, setErrors] = useState({});
//   const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:''})); };

//   const save = async () => {
//     const e = {};
//     if (!form.name.trim()) e.name = 'Business name is required';
//     setErrors(e); if (Object.keys(e).length) return;
//     setSaving(true);
//     try {
//       await api.post('/leads/add', form);
//       toast.success('Lead added!');
//       onAdded();
//       onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to add lead'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><Plus size={16}/> Add Lead Manually</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-group">
//             <label className="form-label">Business Name *</label>
//             <input className={`input${errors.name?' input-error':''}`} value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. ABC Enterprises"/>
//             {errors.name && <div className="form-error">{errors.name}</div>}
//           </div>
//           <div className="form-group">
//             <label className="form-label">Address</label>
//             <input className="input" value={form.address} onChange={e=>set('address',e.target.value)} placeholder="Full address"/>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">Phone</label>
//               <input className="input" value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+91 98765 43210"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Email</label>
//               <input className="input" type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="info@business.com"/>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Website</label>
//             <input className="input" value={form.website} onChange={e=>set('website',e.target.value)} placeholder="https://business.com"/>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">List Name</label>
//               <input className="input" value={form.listName} onChange={e=>set('listName',e.target.value)} placeholder="Default"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Priority</label>
//               <select className="select" value={form.priority} onChange={e=>set('priority',e.target.value)}>
//                 {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//               </select>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Notes</label>
//             <textarea className="textarea" value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Add notes about this lead…"/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving}>
//             {saving ? 'Adding…' : <><Plus size={13}/> Add Lead</>}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Assign Lead Modal ─────────────────────────────────────────────────────
// function AssignModal({ lead, onClose, onDone }) {
//   const [teams,    setTeams]    = useState([]);
//   const [members,  setMembers]  = useState([]);
//   const [teamId,   setTeamId]   = useState('');
//   const [assignTo, setAssignTo] = useState('');
//   const [note,     setNote]     = useState('');
//   const [dueDate,  setDueDate]  = useState('');
//   const [priority, setPriority] = useState('medium');
//   const [saving,   setSaving]   = useState(false);
//   const [loadingT, setLoadingT] = useState(true);

//   useEffect(() => {
//     api.get('/teams').then(r => {
//       const teamList = r.data.teams || [];
//       setTeams(teamList);
//       if (teamList.length === 1) setTeamId(teamList[0].id);
//     }).catch(()=>{}).finally(()=>setLoadingT(false));
//   }, []);

//   useEffect(() => {
//     if (!teamId) { setMembers([]); setAssignTo(''); return; }
//     // getTeam returns { team, members } — members is top-level
//     api.get(`/teams/${teamId}`).then(r => {
//       setMembers(r.data.members || []);
//     }).catch(()=>{});
//   }, [teamId]);

//   const save = async () => {
//     if (!teamId)   { toast.error('Select a team'); return; }
//     if (!assignTo) { toast.error('Select a member'); return; }
//     setSaving(true);
//     try {
//       await api.post('/teams/assign', { savedLeadId: lead.id, assignedTo: assignTo, teamId, note, dueDate: dueDate||undefined, priority });
//       toast.success(`Lead assigned!`);
//       onDone(); onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to assign'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><Send size={15}/> Assign Lead — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           {loadingT ? <div className="spinner"/> : teams.length === 0 ? (
//             <div style={{textAlign:'center',color:'var(--text3)',padding:'20px 0'}}>
//               You are not part of any team yet. Join or create a team to assign leads.
//             </div>
//           ) : (
//             <>
//               <div className="form-group">
//                 <label className="form-label">Team</label>
//                 <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
//                   <option value="">Select team…</option>
//                   {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
//                 </select>
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Assign To</label>
//                 <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
//                   <option value="">Select member…</option>
//                   {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
//                 </select>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label className="form-label">Priority</label>
//                   <select className="select" value={priority} onChange={e=>setPriority(e.target.value)}>
//                     {['low','medium','high','urgent'].map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Due Date</label>
//                   <input className="input" type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Note</label>
//                 <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Add a note for the assignee…" style={{minHeight:60}}/>
//               </div>
//             </>
//           )}
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           {teams.length > 0 && (
//             <button className="btn btn-primary" onClick={save} disabled={saving||!teamId||!assignTo}>
//               {saving ? 'Assigning…' : <><Send size={13}/> Assign</>}
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Reassign Lead Modal ───────────────────────────────────────────────────
// function ReassignModal({ lead, onClose, onDone }) {
//   const [teams,    setTeams]    = useState([]);
//   const [members,  setMembers]  = useState([]);
//   const [teamId,   setTeamId]   = useState(lead.team_id||'');
//   const [assignTo, setAssignTo] = useState('');
//   const [note,     setNote]     = useState('');
//   const [saving,   setSaving]   = useState(false);

//   useEffect(() => {
//     api.get('/teams').then(r => { setTeams(r.data.teams||[]); }).catch(()=>{});
//   }, []);

//   useEffect(() => {
//     if (!teamId) return;
//     // getTeam returns { team, members } — members is top-level
//     api.get(`/teams/${teamId}`).then(r => setMembers(r.data.members||[])).catch(()=>{});
//   }, [teamId]);

//   const save = async () => {
//     if (!assignTo) { toast.error('Select a member'); return; }
//     setSaving(true);
//     try {
//       // transferLead expects { assignmentId, newAssignedTo, note }
//       await api.post('/teams/transfer', { assignmentId: lead.assignment_id || lead.id, transferTo: assignTo, note });
//       toast.success('Lead reassigned!');
//       onDone(); onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to reassign'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><ArrowRightLeft size={15}/> Reassign — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-group">
//             <label className="form-label">Team</label>
//             <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
//               <option value="">Select team…</option>
//               {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
//             </select>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Reassign To</label>
//             <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
//               <option value="">Select member…</option>
//               {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
//             </select>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Note</label>
//             <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Reason for reassigning…" style={{minHeight:60}}/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving||!assignTo}>
//             {saving ? 'Reassigning…' : <><ArrowRightLeft size={13}/> Reassign</>}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Lead Row (shared for saved + assigned) ────────────────────────────────
// function LeadRow({ lead, isAssigned, onEdit, onDelete, onAssign, onReassign, onDetail, toggleSel, selected }) {
//   return (
//     <tr key={lead.id}>
//       <td>
//         {!isAssigned && (
//           <input type="checkbox" className="table-checkbox"
//             checked={selected?.includes(lead.id)} onChange={()=>toggleSel(lead.id)}/>
//         )}
//       </td>
//       <td>
//         <div style={{ fontWeight:600, fontSize:13.5, color:'var(--text)', marginBottom:3 }}>{lead.name}</div>
//         {lead.address && (
//           <div style={{ fontSize:12, color:'var(--text3)', display:'flex', alignItems:'center', gap:4 }}>
//             <MapPin size={10}/>{lead.address.substring(0,50)}{lead.address.length>50?'…':''}
//           </div>
//         )}
//       </td>
//       <td>
//         {lead.phone && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
//           <Phone size={11} style={{color:'var(--accent)'}}/><a href={`tel:${lead.phone}`} style={{color:'var(--accent)'}}>{lead.phone}</a>
//         </div>}
//         {lead.email && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
//           <Mail size={11} style={{color:'var(--accent)'}}/><a href={`mailto:${lead.email}`} style={{color:'var(--accent)',overflow:'hidden',textOverflow:'ellipsis',maxWidth:160,display:'block'}}>{lead.email}</a>
//         </div>}
//         {lead.website && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12 }}>
//           <Globe size={11} style={{color:'var(--accent)'}}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',maxWidth:140,overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a>
//         </div>}
//       </td>
//       <td>
//         {lead.rating ? <div style={{ display:'flex', alignItems:'center', gap:4, fontWeight:600, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/>{Number(lead.rating).toFixed(1)}</div> : <span style={{color:'var(--text3)'}}>—</span>}
//       </td>
//       <td>
//         <div style={{ display:'flex', alignItems:'center', gap:6 }}>
//           <div className="score-track" style={{width:50}}>
//             <div className={`score-fill ${(lead.lead_score||0)>=70?'high':(lead.lead_score||0)>=40?'mid':'low'}`} style={{width:`${lead.lead_score||0}%`}}/>
//           </div>
//           <span style={{ fontSize:12, fontWeight:700, color:(lead.lead_score||0)>=70?'var(--green)':(lead.lead_score||0)>=40?'var(--gold)':'var(--red)' }}>{lead.lead_score||0}</span>
//         </div>
//       </td>
//       <td>
//         {isAssigned ? (
//           <select className="select" style={{width:110,height:28,fontSize:12}}
//             value={lead.status||'pending'}
//             onChange={async e => {
//               try {
//                 await api.put(`/teams/assignments/${lead.assignment_id || lead.id}`, { status: e.target.value });
//                 lead.status = e.target.value;
//                 toast.success('Status updated');
//               } catch { toast.error('Failed to update'); }
//             }}>
//             {['pending','in_progress','converted','lost'].map(s=>(
//               <option key={s} value={s}>{s.replace('_',' ').replace(/^\w/,c=>c.toUpperCase())}</option>
//             ))}
//           </select>
//         ) : (
//           <span className={`badge ${STATUS_COLORS[lead.status]||'badge-gray'}`}><span className="badge-dot"/>{lead.status||'new'}</span>
//         )}
//       </td>
//       <td>
//         <span className={`badge ${PRIORITY_COLORS[lead.priority]||'badge-gray'}`}>
//           {lead.priority||'medium'}
//         </span>
//       </td>
//       <td>
//         {isAssigned ? (
//           <div style={{ fontSize:12, color:'var(--text2)' }}>
//             <div>{lead.assigned_by_name}</div>
//             {lead.team_name && <div style={{color:'var(--text3)',fontSize:11}}>{lead.team_name}</div>}
//           </div>
//         ) : (
//           <span style={{ fontSize:12, color:'var(--text2)' }}>{lead.list_name||'Default'}</span>
//         )}
//       </td>
//       <td>
//         {lead.follow_up_date ? (
//           <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12, color:new Date(lead.follow_up_date)<new Date()?'var(--red)':'var(--text2)' }}>
//             <Calendar size={11}/>{new Date(lead.follow_up_date).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}
//           </div>
//         ) : <span style={{color:'var(--text3)'}}>—</span>}
//       </td>
//       <td>
//         <div style={{ display:'flex', gap:4 }}>
//           <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDetail(lead)} title="View details"><MessageSquare size={13}/></button>
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onEdit(lead)} title="Edit"><Edit3 size={13}/></button>}
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onAssign(lead)} title="Assign to team member"><Send size={13}/></button>}
//           {isAssigned  && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onReassign(lead)} title="Reassign"><ArrowRightLeft size={13}/></button>}
//           {lead.google_maps_url && <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-icon btn-sm" title="View on Map"><ExternalLink size={13}/></a>}
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDelete(lead.id)} title="Remove" style={{color:'var(--red)'}}><Trash2 size={13}/></button>}
//         </div>
//       </td>
//     </tr>
//   );
// }

// // ── Main Page ─────────────────────────────────────────────────────────────
// export default function SavedLeadsPage() {
//   const [tab,        setTab]       = useState('saved');   // 'saved' | 'assigned'
//   const [leads,      setLeads]     = useState([]);
//   const [total,      setTotal]     = useState(0);
//   const [loading,    setLoading]   = useState(true);
//   const [search,     setSearch]    = useState('');
//   const [statusF,    setStatusF]   = useState('');
//   const [priorityF,  setPriorityF] = useState('');
//   const [listF,      setListF]     = useState('');
//   const [page,       setPage]      = useState(1);
//   const [editLead,     setEditLead]    = useState(null);
//   const [showAdd,      setShowAdd]     = useState(false);
//   const [assignLead,   setAssignLead]  = useState(null);
//   const [reassignLead, setReassignLead]= useState(null);
//   const [detailLead,   setDetailLead] = useState(null);
//   const [selected,     setSelected]   = useState([]);
//   const PER = 20;

//   const load = async (pg=1) => {
//     setLoading(true);
//     try {
//       const endpoint = tab === 'assigned' ? '/leads/assigned' : '/leads/saved';
//       const params   = { page:pg, limit:PER };
//       if (tab === 'saved') {
//         if (search)    params.search   = search;
//         if (statusF)   params.status   = statusF;
//         if (priorityF) params.priority = priorityF;
//         if (listF)     params.list     = listF;
//       } else {
//         if (statusF)   params.status   = statusF;
//         if (priorityF) params.priority = priorityF;
//       }
//       const r = await api.get(endpoint, { params });
//       setLeads(r.data.leads||[]);
//       setTotal(r.data.total||0);
//       setPage(pg);
//     } catch { toast.error('Failed to load leads'); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => { load(1); }, [tab, statusF, priorityF, listF]);

//   const updateLead = async (id, data) => {
//     await api.put(`/leads/saved/${id}`, { status:data.status, priority:data.priority, notes:data.notes, listName:data.listName, followUpDate:data.followUpDate||null });
//     toast.success('Lead updated'); load(page);
//   };
//   const deleteLead = async (id) => {
//     if (!window.confirm('Remove this lead?')) return;
//     await api.delete(`/leads/saved/${id}`); toast.success('Removed'); load(page);
//   };
//   const deleteSelected = async () => {
//     if (!window.confirm(`Delete ${selected.length} leads?`)) return;
//     await Promise.all(selected.map(id => api.delete(`/leads/saved/${id}`).catch(()=>{})));
//     setSelected([]); toast.success(`${selected.length} leads removed`); load(1);
//   };
//   const exportCSV = () => {
//     const rows = selected.length>0 ? leads.filter(l=>selected.includes(l.id)) : leads;
//     const cols = ['name','address','phone','email','website','rating','lead_score','status','priority','list_name','notes'];
//     const csv  = [cols.join(','), ...rows.map(l=>cols.map(c=>`"${(l[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
//     const a = document.createElement('a'); a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'})); a.download='saved_leads.csv'; a.click();
//     toast.success(`Exported ${rows.length} leads`);
//   };
//   const toggleSel   = id => setSelected(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);
//   const totalPages  = Math.ceil(total/PER);
//   const lists       = [...new Set(leads.map(l=>l.list_name).filter(Boolean))];

//   return (
//     <div style={{ maxWidth:1300, margin:'0 auto', padding:'24px' }}>

//       {/* Header */}
//       <div className="flex-between mb-20">
//         <div>
//           <h1 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:800, marginBottom:4 }}>Saved Leads</h1>
//           <p style={{ color:'var(--text3)', fontSize:14 }}>{total.toLocaleString()} leads</p>
//         </div>
//         <div style={{ display:'flex', gap:8 }}>
//           {tab==='saved' && selected.length>0 && (
//             <button className="btn btn-danger btn-sm" onClick={deleteSelected}><Trash2 size={13}/> Delete ({selected.length})</button>
//           )}
//           {tab==='saved' && (
//             <>
//               <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead</button>
//               <button className="btn btn-success btn-sm" onClick={exportCSV}><Download size={13}/> Export {selected.length>0?`(${selected.length})`:'CSV'}</button>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Tabs */}
//       <div style={{ display:'flex', gap:4, marginBottom:16, borderBottom:'2px solid var(--border)', paddingBottom:0 }}>
//         {[
//           { id:'saved',    label:'My Saved Leads', icon:<Bookmark size={14}/> },
//           { id:'assigned', label:'Assigned to Me',  icon:<UserCheck size={14}/> },
//         ].map(t=>(
//           <button key={t.id} onClick={()=>{setTab(t.id);setStatusF('');setPriorityF('');setSelected([]);}}
//             style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 16px', borderRadius:'8px 8px 0 0',
//               border:'none', cursor:'pointer', fontSize:13.5, fontWeight:tab===t.id?700:500,
//               background:tab===t.id?'var(--surface)':'transparent',
//               color:tab===t.id?'var(--accent)':'var(--text3)',
//               borderBottom:tab===t.id?'2px solid var(--accent)':'2px solid transparent',
//               marginBottom:-2 }}>
//             {t.icon}{t.label}
//           </button>
//         ))}
//       </div>

//       {/* Filters */}
//       <div className="toolbar mb-16">
//         <div className="toolbar-left">
//           {tab==='saved' && (
//             <div className="input-group" style={{minWidth:220}}>
//               <Search size={14} className="input-icon"/>
//               <input className="input" placeholder="Search leads…" value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load(1)}/>
//             </div>
//           )}
//           <select className="select" style={{width:140}} value={statusF} onChange={e=>setStatusF(e.target.value)}>
//             <option value="">All Statuses</option>
//             {STATUS_OPTS.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
//           </select>
//           <select className="select" style={{width:130}} value={priorityF} onChange={e=>setPriorityF(e.target.value)}>
//             <option value="">All Priorities</option>
//             {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//           </select>
//           {tab==='saved' && lists.length>0 && (
//             <select className="select" style={{width:150}} value={listF} onChange={e=>setListF(e.target.value)}>
//               <option value="">All Lists</option>
//               {lists.map(l=><option key={l} value={l}>{l}</option>)}
//             </select>
//           )}
//         </div>
//         {tab==='saved' && (
//           <div className="toolbar-right">
//             <button className="btn btn-ghost btn-sm" onClick={()=>leads.length===selected.length?setSelected([]):setSelected(leads.map(l=>l.id))}>
//               {leads.length===selected.length?'Deselect All':'Select All'}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Status Summary — saved tab only */}
//       {tab==='saved' && (
//         <div className="grid-stats mb-16">
//           {STATUS_OPTS.map(s => {
//             const count = leads.filter(l=>l.status===s).length;
//             return (
//               <div key={s} className="card card-sm" style={{ cursor:'pointer', border:statusF===s?'2px solid var(--accent)':'1px solid var(--border)' }}
//                 onClick={()=>setStatusF(statusF===s?'':s)}>
//                 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
//                   <span className={`badge ${STATUS_COLORS[s]}`}><span className="badge-dot"/>{s.charAt(0).toUpperCase()+s.slice(1)}</span>
//                   <span style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:800 }}>{count}</span>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* Table — saved tab only */}
//       {loading ? (
//         <div className="empty-state"><div className="spinner spinner-lg"/></div>
//       ) : leads.length===0 ? (
//         <div className="empty-state">
//           <div className="empty-icon">{tab==='assigned'?<UserCheck size={26}/>:<Bookmark size={26}/>}</div>
//           <div className="empty-title">{tab==='assigned'?'No leads assigned to you':'No saved leads yet'}</div>
//           <div className="empty-sub">
//             {tab==='assigned'
//               ? 'When a team member assigns a lead to you, it will appear here.'
//               : 'Search for businesses and save the ones you want to follow up with.'}
//           </div>
//           {tab==='saved' && <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead Manually</button>}
//         </div>

//       ) : tab==='saved' ? (
//         <>
//           <div className="table-wrap">
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th><input type="checkbox" className="table-checkbox" checked={selected.length===leads.length&&leads.length>0} onChange={e=>e.target.checked?setSelected(leads.map(l=>l.id)):setSelected([])}/></th>
//                   <th>Business</th>
//                   <th>Contact</th>
//                   <th>Rating</th>
//                   <th>Score</th>
//                   <th>Status</th>
//                   <th>Priority</th>
//                   <th>List</th>
//                   <th>Follow-up</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {leads.map(lead=>(
//                   <LeadRow key={lead.id} lead={lead} isAssigned={false}
//                     onEdit={setEditLead} onDelete={deleteLead}
//                     onAssign={setAssignLead} onReassign={setReassignLead}
//                     onDetail={setDetailLead}
//                     toggleSel={toggleSel} selected={selected}/>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           {totalPages>1 && (
//             <div className="pagination mt-16">
//               <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
//               <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
//               <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
//             </div>
//           )}
//         </>

//       ) : (
//         /* ── Assigned tab — exact same card UI as TeamPage MyAssignedLeads ── */
//         <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
//           {leads.map(lead => (
//             <div key={lead.id} className="card" style={{ padding:'14px 16px', borderLeft:`3px solid ${priColor(lead.priority)}` }}>
//               <div style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:10 }}>
//                 <div style={{ flex:1, minWidth:0 }}>
//                   <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:5 }}>
//                     <div style={{ fontWeight:700, fontSize:14 }}>{lead.name}</div>
//                     <span className={`badge ${statusBadge(lead.status)}`}><span className="badge-dot"/>{statusLabel(lead.status)}</span>
//                     {lead.priority && <span style={{ fontSize:11, fontWeight:700, color:priColor(lead.priority) }}>● {lead.priority}</span>}
//                     {isOverdue(lead.due_date) && <span className="badge badge-red"><AlertTriangle size={9}/>Overdue</span>}
//                   </div>
//                   <div style={{ display:'flex', gap:14, fontSize:12.5, color:'var(--text3)', flexWrap:'wrap' }}>
//                     {lead.phone && <span>📞 {lead.phone}</span>}
//                     {lead.team_name && <span>👥 {lead.team_name}</span>}
//                     {lead.due_date && <span style={{ color:isOverdue(lead.due_date)?'var(--red)':'var(--text3)' }}>📅 {fmtDate(lead.due_date)}</span>}
//                     {lead.assigned_by_name && <span>By {lead.assigned_by_name}</span>}
//                     {lead.last_comment && <span style={{ fontStyle:'italic' }}>💬 {lead.last_comment.substring(0,40)}{lead.last_comment.length>40?'…':''}</span>}
//                   </div>
//                 </div>
//                 <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>setDetailLead(lead)} title="Comments & details">
//                   <MessageSquare size={14}/>
//                 </button>
//               </div>
//               {lead.note && <div style={{ fontSize:12.5, background:'var(--bg3)', borderRadius:7, padding:'6px 10px', marginBottom:10, color:'var(--text2)' }}>💬 {lead.note}</div>}
//               {/* Quick status buttons — exact same as TeamPage */}
//               <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
//                 {STATUSES.map(s => (
//                   <button key={s.value}
//                     className={`badge ${s.cls}`}
//                     style={{ cursor:'pointer', padding:'4px 9px', fontSize:11.5, border:`2px solid ${lead.status===s.value?'currentColor':'transparent'}`, opacity:lead.status===s.value?1:0.55, transition:'opacity .15s' }}
//                     onClick={async () => {
//                       try {
//                         await api.put(`/teams/assignments/${lead.assignment_id}`, { status: s.value });
//                         setLeads(prev => prev.map(l => l.assignment_id===lead.assignment_id ? {...l, status:s.value} : l));
//                         toast.success(`→ ${s.label}`);
//                       } catch { toast.error('Failed to update'); }
//                     }}>
//                     {lead.status===s.value && <Check size={9}/>}{s.label}
//                   </button>
//                 ))}
//                 <button className="btn btn-ghost btn-sm" style={{ marginLeft:'auto', fontSize:12 }} onClick={()=>setReassignLead(lead)}>
//                   <ArrowRightLeft size={12}/> Reassign
//                 </button>
//                 {lead.google_maps_url && (
//                   <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm" style={{ textDecoration:'none', fontSize:12 }}>
//                     <ExternalLink size={12}/>
//                   </a>
//                 )}
//               </div>
//             </div>
//           ))}
//           {totalPages>1 && (
//             <div className="pagination mt-16">
//               <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
//               <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
//               <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
//             </div>
//           )}
//         </div>
//       )}

//       {editLead    && <EditModal lead={editLead} onClose={()=>setEditLead(null)} onSave={updateLead}/>}
//       {showAdd     && <AddLeadModal onClose={()=>setShowAdd(false)} onAdded={()=>load(1)}/>}
//       {assignLead  && <AssignModal lead={assignLead} onClose={()=>setAssignLead(null)} onDone={()=>load(page)}/>}
//       {reassignLead && <ReassignModal lead={reassignLead} onClose={()=>setReassignLead(null)} onDone={()=>load(page)}/>}
//       {detailLead  && <LeadPanel lead={detailLead} isAssigned={tab==='assigned'} onClose={()=>setDetailLead(null)} onRefresh={async ()=>{ await load(page); setDetailLead(null); }}/>}
//     </div>
//   );
// }


// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Bookmark, Search, Download, Trash2, Edit3, X, Star, Phone, Globe,
//   ExternalLink, MapPin, ChevronLeft, ChevronRight, Calendar, Plus,
//   UserCheck, Mail, Send, ArrowRightLeft, MessageSquare, Check, Clock,
//   AlertTriangle, RefreshCw } from 'lucide-react';
// import api from '../utils/api';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// const STATUS_OPTS    = ['new','contacted','qualified','converted','lost'];
// const PRIORITY_OPTS  = ['low','medium','high','urgent'];
// const STATUS_COLORS  = { new:'badge-blue', contacted:'badge-gold', qualified:'badge-purple', converted:'badge-green', lost:'badge-red' };
// const PRIORITY_COLORS= { low:'badge-gray', medium:'badge-blue', high:'badge-gold', urgent:'badge-red' };

// const STATUSES = [
//   { value:'pending',     label:'Pending',     cls:'badge-gray'   },
//   { value:'in_progress', label:'In Progress', cls:'badge-blue'   },
//   { value:'contacted',   label:'Contacted',   cls:'badge-gold'   },
//   { value:'qualified',   label:'Qualified',   cls:'badge-purple' },
//   { value:'converted',   label:'Converted',   cls:'badge-green'  },
//   { value:'lost',        label:'Lost',        cls:'badge-red'    },
// ];
// const statusLabel = s => STATUSES.find(x=>x.value===s)?.label || STATUS_OPTS.find(x=>x===s) || s || '—';
// const statusBadge = s => STATUSES.find(x=>x.value===s)?.cls || STATUS_COLORS[s] || 'badge-gray';
// const priColor    = p => ({ urgent:'#ef4444', high:'#f97316', medium:'#f59e0b', low:'#94a3b8' }[p] || '#94a3b8');
// const fmtDate     = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'}) : '—';
// const isOverdue   = d => d && new Date(d) < new Date();

// // ── Lead Detail Side Panel (from TeamPage) ────────────────────────────────
// function LeadPanel({ lead, isAssigned, onClose, onRefresh }) {
//   const { user }               = useAuth();
//   const [comments, setComments]= useState([]);
//   const [activity, setActivity]= useState([]);
//   const [newComment, setComment]= useState('');
//   const [posting, setPosting]  = useState(false);
//   const [tab, setTab]          = useState('details');
//   const [stLd, setStLd]        = useState(false);
//   const bottomRef              = useRef(null);

//   const savedLeadId = lead.saved_lead_id || lead.id;
//   const teamId      = lead.team_id || '';
//   const assignmentId = lead.assignment_id || '';

//   const loadComments = useCallback(async () => {
//     try {
//       if (isAssigned && teamId) {
//         // Assigned lead — use team comments API
//         const [cr, ar] = await Promise.all([
//           api.get('/teams/comments', { params:{ savedLeadId, teamId } }),
//           api.get('/teams/activity',  { params:{ savedLeadId, teamId } }),
//         ]);
//         setComments(cr.data.comments||[]);
//         setActivity(ar.data.activity||[]);
//       } else {
//         // Saved lead — use personal comments API
//         const r = await api.get(`/leads/saved/${lead.id}/comments`);
//         setComments(r.data.comments||[]);
//       }
//     } catch {}
//   }, [savedLeadId, teamId, lead.id, isAssigned]);

//   const postComment = async e => {
//     e.preventDefault();
//     if (!newComment.trim()) return;
//     setPosting(true);
//     try {
//       if (isAssigned && teamId) {
//         const r = await api.post('/teams/comments', { savedLeadId, teamId, comment: newComment.trim() });
//         setComments(c => [...c, r.data.comment]);
//       } else {
//         const r = await api.post(`/leads/saved/${lead.id}/comments`, { comment: newComment.trim() });
//         setComments(c => [...c, r.data.comment]);
//       }
//       setComment('');
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
//     finally { setPosting(false); }
//   };

//   const delComment = async id => {
//     try {
//       if (isAssigned && teamId) {
//         await api.delete(`/teams/comments/${id}`);
//       } else {
//         await api.delete(`/leads/saved/${lead.id}/comments/${id}`);
//       }
//       setComments(c => c.filter(x=>x.id!==id));
//     } catch { toast.error('Failed'); }
//   };

//   useEffect(() => { loadComments(); }, [loadComments]);
//   useEffect(() => { if (tab==='comments') bottomRef.current?.scrollIntoView({ behavior:'smooth' }); }, [comments, tab]);

//   const [localStatus, setLocalStatus] = useState(lead.status || 'new');

//   const changeStatus = async status => {
//     setStLd(true);
//     try {
//       if (isAssigned && assignmentId) {
//         await api.put(`/teams/assignments/${assignmentId}`, { status });
//       } else {
//         await api.put(`/leads/saved/${lead.id}`, { status });
//       }
//       setLocalStatus(status);
//       toast.success(`Status → ${statusLabel(status)}`);
//       onRefresh();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
//     finally { setStLd(false); }
//   };

//   return (
//     <>
//       <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:199 }} onClick={onClose}/>
//       <div style={{ position:'fixed', top:0, right:0, bottom:0, width:'min(480px,100vw)', background:'var(--surface)', borderLeft:'1px solid var(--border)', zIndex:200, display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,.2)', overflowY:'auto' }}>

//         {/* Header */}
//         <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'flex-start', gap:10, position:'sticky', top:0, background:'var(--surface)', zIndex:1 }}>
//           <div style={{ flex:1, minWidth:0 }}>
//             <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>{lead.name}</div>
//             <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
//               <span className={`badge ${statusBadge(localStatus)}`}><span className="badge-dot"/>{statusLabel(localStatus)}</span>
//               {lead.priority && <span style={{ fontSize:11.5, fontWeight:700, color:priColor(lead.priority) }}>● {lead.priority}</span>}
//               {lead.follow_up_date && <span style={{ fontSize:11.5, color:isOverdue(lead.follow_up_date)?'var(--red)':'var(--text3)' }}>📅 {fmtDate(lead.follow_up_date)}</span>}
//             </div>
//           </div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={15}/></button>
//         </div>

//         {/* Contact */}
//         <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)', display:'flex', flexDirection:'column', gap:6 }}>
//           {lead.phone   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Phone size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`tel:${lead.phone}`} style={{ color:'var(--text2)', textDecoration:'none' }}>{lead.phone}</a></div>}
//           {lead.email   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Mail size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`mailto:${lead.email}`} style={{ color:'var(--accent)', textDecoration:'none' }}>{lead.email}</a></div>}
//           {lead.website && <div style={{ display:'flex', gap:8, fontSize:13 }}><Globe size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{ color:'var(--accent)', textDecoration:'none', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a></div>}
//           {lead.address && <div style={{ display:'flex', gap:8, fontSize:12.5, color:'var(--text3)' }}><MapPin size={13} style={{ flexShrink:0, marginTop:1 }}/>{lead.address}</div>}
//           {/* Owner / assigned info */}
//           {lead.list_name && !isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>📋 List: <strong style={{ color:'var(--text)' }}>{lead.list_name}</strong></div>}
//           {lead.assigned_to_name && !isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👤 Assigned to: <strong style={{ color:'var(--accent)' }}>{lead.assigned_to_name}</strong></div>}
//           {lead.assigned_by_name && isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👤 Assigned by: <strong style={{ color:'var(--text)' }}>{lead.assigned_by_name}</strong></div>}
//           {lead.team_name && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👥 Team: <strong style={{ color:'var(--text)' }}>{lead.team_name}</strong></div>}
//           {lead.rating && <div style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/><strong>{Number(lead.rating).toFixed(1)}</strong><span style={{ color:'var(--text3)', fontSize:12 }}>({lead.review_count||0} reviews)</span></div>}
//           {lead.lead_score > 0 && <div style={{ fontSize:12.5, color:'var(--text3)' }}>🎯 Lead Score: <strong style={{ color:'var(--text)' }}>{lead.lead_score}</strong></div>}
//         </div>

//         {/* Status change — all leads */}
//         <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)' }}>
//           <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>Update Status</div>
//           <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
//             {(isAssigned ? STATUSES : [
//               { value:'new',       label:'New',       cls:'badge-blue'   },
//               { value:'contacted', label:'Contacted', cls:'badge-gold'   },
//               { value:'qualified', label:'Qualified', cls:'badge-purple' },
//               { value:'converted', label:'Converted', cls:'badge-green'  },
//               { value:'lost',      label:'Lost',      cls:'badge-red'    },
//             ]).map(s => (
//               <button key={s.value} onClick={() => changeStatus(s.value)} disabled={stLd}
//                 className={`badge ${s.cls}`}
//                 style={{ cursor:'pointer', padding:'5px 11px', border:`2px solid ${localStatus===s.value?'currentColor':'transparent'}`, fontSize:12, opacity:localStatus===s.value?1:0.6, transition:'all .15s' }}>
//                 {localStatus===s.value && <Check size={10}/>}{s.label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Tabs */}
//         <div style={{ display:'flex', borderBottom:'1px solid var(--border)', padding:'0 20px' }}>
//           {[['details','📋 Details'], ['comments',`💬 Comments (${comments.length})`], ...(teamId?[['activity','📋 Activity']]:[])]
//             .map(([v,l]) => (
//               <button key={v} onClick={() => { setTab(v); if(v==='comments'||v==='activity') loadComments(); }}
//                 style={{ padding:'10px 14px', border:'none', background:'none', fontWeight:tab===v?700:500, fontSize:13, color:tab===v?'var(--accent)':'var(--text3)', cursor:'pointer', borderBottom:tab===v?'2px solid var(--accent)':'2px solid transparent', marginBottom:-1 }}>
//                 {l}
//               </button>
//             ))
//           }
//         </div>

//         {/* Details tab */}
//         {tab==='details' && (
//           <div style={{ padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//             {lead.notes && (
//               <div style={{ background:'var(--bg3)', borderRadius:8, padding:'10px 14px', fontSize:13.5, color:'var(--text2)', lineHeight:1.6 }}>
//                 <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', marginBottom:6, textTransform:'uppercase', letterSpacing:.8 }}>Notes</div>
//                 {lead.notes}
//               </div>
//             )}
//             {lead.google_maps_url && (
//               <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-full" style={{ textDecoration:'none', justifyContent:'center' }}>
//                 <ExternalLink size={13}/> View on Map
//               </a>
//             )}
//           </div>
//         )}

//         {/* Comments tab */}
//         {tab==='comments' && (
//           <div style={{ flex:1, display:'flex', flexDirection:'column' }}>
//             {!teamId ? (
//               <div style={{ flex:1, padding:'32px 20px', textAlign:'center', color:'var(--text3)', fontSize:13 }}>
//                 <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
//                 <div>Comments are available for team-assigned leads only.</div>
//                 <div style={{ fontSize:12, marginTop:6 }}>Assign this lead to a team member to enable comments.</div>
//               </div>
//             ) : (
//               <>
//                 <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//                   {comments.length===0 && (
//                     <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
//                       <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
//                       <div>No comments yet</div>
//                     </div>
//                   )}
//                   {comments.map(c => (
//                     <div key={c.id} style={{ display:'flex', gap:10 }}>
//                       <div style={{ width:32, height:32, borderRadius:'50%', background:'linear-gradient(135deg,var(--accent),var(--accent2))', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:12, fontWeight:700, flexShrink:0 }}>
//                         {c.first_name?.[0]}{c.last_name?.[0]}
//                       </div>
//                       <div style={{ flex:1 }}>
//                         <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
//                           <span style={{ fontWeight:600, fontSize:13 }}>{c.first_name} {c.last_name}</span>
//                           <span style={{ fontSize:11, color:'var(--text3)' }}>{new Date(c.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</span>
//                           {c.user_id===user?.id && <button onClick={()=>delComment(c.id)} style={{ marginLeft:'auto', background:'none', border:'none', color:'var(--text3)', cursor:'pointer', padding:2, display:'flex', borderRadius:4 }}><Trash2 size={11}/></button>}
//                         </div>
//                         <div style={{ background:'var(--bg3)', borderRadius:'4px 12px 12px 12px', padding:'8px 12px', fontSize:13.5, lineHeight:1.5, wordBreak:'break-word' }}>{c.comment}</div>
//                       </div>
//                     </div>
//                   ))}
//                   <div ref={bottomRef}/>
//                 </div>
//                 <div style={{ padding:'12px 20px', borderTop:'1px solid var(--border)' }}>
//                   <form onSubmit={postComment} style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
//                     <textarea className="textarea" style={{ flex:1, minHeight:40, maxHeight:100, resize:'none', fontSize:13.5 }}
//                       placeholder="Add a comment… (Enter to send)"
//                       value={newComment} onChange={e=>setComment(e.target.value)}
//                       onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();postComment(e);} }}/>
//                     <button type="submit" className="btn btn-primary" style={{ padding:'8px 12px', flexShrink:0 }} disabled={posting||!newComment.trim()}>
//                       {posting?<div className="spinner spinner-sm"/>:<Send size={14}/>}
//                     </button>
//                   </form>
//                 </div>
//               </>
//             )}
//           </div>
//         )}

//         {/* Activity tab */}
//         {tab==='activity' && teamId && (
//           <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
//             {activity.length===0 && (
//               <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
//                 <Clock size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/><div>No activity yet</div>
//               </div>
//             )}
//             {activity.map(a => (
//               <div key={a.id} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
//                 <div style={{ width:28, height:28, borderRadius:'50%', background:'var(--bg3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>
//                   {({assigned:'🎯',transferred:'↔️',status_changed:'🔄',comment_added:'💬'}[a.action]||'📋')}
//                 </div>
//                 <div style={{ flex:1 }}>
//                   <div style={{ fontSize:13, color:'var(--text2)', lineHeight:1.5 }}>
//                     <strong>{a.first_name} {a.last_name}</strong>{' '}
//                     {a.action==='assigned' && 'assigned this lead'}
//                     {a.action==='transferred' && 'transferred this lead'}
//                     {a.action==='status_changed' && <><span style={{ color:'var(--text3)' }}>changed status to </span><strong>{statusLabel(a.new_value)}</strong></>}
//                     {a.action==='comment_added' && 'added a comment'}
//                   </div>
//                   {a.note && a.action!=='comment_added' && <div style={{ fontSize:12, color:'var(--text3)', fontStyle:'italic', marginTop:2 }}>"{a.note}"</div>}
//                   <div style={{ fontSize:11, color:'var(--text3)', marginTop:3 }}>{new Date(a.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Edit Modal ────────────────────────────────────────────────────────────
// function EditModal({ lead, onClose, onSave }) {
//   const [form, setForm] = useState({
//     status: lead.status||'new', priority: lead.priority||'medium',
//     notes: lead.notes||'', listName: lead.list_name||'Default',
//     followUpDate: lead.follow_up_date?.split('T')[0]||''
//   });
//   const [saving, setSaving] = useState(false);
//   const save = async () => {
//     setSaving(true);
//     try { await onSave(lead.id, form); onClose(); }
//     catch { toast.error('Failed to save'); }
//     finally { setSaving(false); }
//   };
//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title">Edit Lead — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">CRM Status</label>
//               <select className="select" value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>
//                 {STATUS_OPTS.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
//               </select>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Priority</label>
//               <select className="select" value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))}>
//                 {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//               </select>
//             </div>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">List Name</label>
//               <input className="input" value={form.listName} onChange={e=>setForm(f=>({...f,listName:e.target.value}))} placeholder="Default"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Follow-up Date</label>
//               <input className="input" type="date" value={form.followUpDate} onChange={e=>setForm(f=>({...f,followUpDate:e.target.value}))}/>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Notes</label>
//             <textarea className="textarea" value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Add notes…"/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Add Lead Modal ────────────────────────────────────────────────────────
// function AddLeadModal({ onClose, onAdded }) {
//   const [form, setForm] = useState({
//     name:'', address:'', phone:'', email:'', website:'',
//     listName:'Default', priority:'medium', notes:''
//   });
//   const [saving, setSaving] = useState(false);
//   const [errors, setErrors] = useState({});
//   const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:''})); };

//   const save = async () => {
//     const e = {};
//     if (!form.name.trim()) e.name = 'Business name is required';
//     setErrors(e); if (Object.keys(e).length) return;
//     setSaving(true);
//     try {
//       await api.post('/leads/add', form);
//       toast.success('Lead added!');
//       onAdded();
//       onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to add lead'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><Plus size={16}/> Add Lead Manually</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-group">
//             <label className="form-label">Business Name *</label>
//             <input className={`input${errors.name?' input-error':''}`} value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. ABC Enterprises"/>
//             {errors.name && <div className="form-error">{errors.name}</div>}
//           </div>
//           <div className="form-group">
//             <label className="form-label">Address</label>
//             <input className="input" value={form.address} onChange={e=>set('address',e.target.value)} placeholder="Full address"/>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">Phone</label>
//               <input className="input" value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+91 98765 43210"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Email</label>
//               <input className="input" type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="info@business.com"/>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Website</label>
//             <input className="input" value={form.website} onChange={e=>set('website',e.target.value)} placeholder="https://business.com"/>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">List Name</label>
//               <input className="input" value={form.listName} onChange={e=>set('listName',e.target.value)} placeholder="Default"/>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Priority</label>
//               <select className="select" value={form.priority} onChange={e=>set('priority',e.target.value)}>
//                 {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//               </select>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Notes</label>
//             <textarea className="textarea" value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Add notes about this lead…"/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving}>
//             {saving ? 'Adding…' : <><Plus size={13}/> Add Lead</>}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Assign Lead Modal ─────────────────────────────────────────────────────
// function AssignModal({ lead, onClose, onDone }) {
//   const [teams,    setTeams]    = useState([]);
//   const [members,  setMembers]  = useState([]);
//   const [teamId,   setTeamId]   = useState('');
//   const [assignTo, setAssignTo] = useState('');
//   const [note,     setNote]     = useState('');
//   const [dueDate,  setDueDate]  = useState('');
//   const [priority, setPriority] = useState('medium');
//   const [saving,   setSaving]   = useState(false);
//   const [loadingT, setLoadingT] = useState(true);

//   useEffect(() => {
//     api.get('/teams').then(r => {
//       const teamList = r.data.teams || [];
//       setTeams(teamList);
//       if (teamList.length === 1) setTeamId(teamList[0].id);
//     }).catch(()=>{}).finally(()=>setLoadingT(false));
//   }, []);

//   useEffect(() => {
//     if (!teamId) { setMembers([]); setAssignTo(''); return; }
//     // getTeam returns { team, members } — members is top-level
//     api.get(`/teams/${teamId}`).then(r => {
//       setMembers(r.data.members || []);
//     }).catch(()=>{});
//   }, [teamId]);

//   const save = async () => {
//     if (!teamId)   { toast.error('Select a team'); return; }
//     if (!assignTo) { toast.error('Select a member'); return; }
//     setSaving(true);
//     try {
//       await api.post('/teams/assign', { savedLeadId: lead.id, assignedTo: assignTo, teamId, note, dueDate: dueDate||undefined, priority });
//       toast.success(`Lead assigned!`);
//       onDone(); onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to assign'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><Send size={15}/> Assign Lead — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           {loadingT ? <div className="spinner"/> : teams.length === 0 ? (
//             <div style={{textAlign:'center',color:'var(--text3)',padding:'20px 0'}}>
//               You are not part of any team yet. Join or create a team to assign leads.
//             </div>
//           ) : (
//             <>
//               <div className="form-group">
//                 <label className="form-label">Team</label>
//                 <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
//                   <option value="">Select team…</option>
//                   {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
//                 </select>
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Assign To</label>
//                 <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
//                   <option value="">Select member…</option>
//                   {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
//                 </select>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label className="form-label">Priority</label>
//                   <select className="select" value={priority} onChange={e=>setPriority(e.target.value)}>
//                     {['low','medium','high','urgent'].map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Due Date</label>
//                   <input className="input" type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Note</label>
//                 <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Add a note for the assignee…" style={{minHeight:60}}/>
//               </div>
//             </>
//           )}
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           {teams.length > 0 && (
//             <button className="btn btn-primary" onClick={save} disabled={saving||!teamId||!assignTo}>
//               {saving ? 'Assigning…' : <><Send size={13}/> Assign</>}
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Reassign Lead Modal ───────────────────────────────────────────────────
// function ReassignModal({ lead, onClose, onDone }) {
//   const [teams,    setTeams]    = useState([]);
//   const [members,  setMembers]  = useState([]);
//   const [teamId,   setTeamId]   = useState(lead.team_id||'');
//   const [assignTo, setAssignTo] = useState('');
//   const [note,     setNote]     = useState('');
//   const [saving,   setSaving]   = useState(false);

//   useEffect(() => {
//     api.get('/teams').then(r => { setTeams(r.data.teams||[]); }).catch(()=>{});
//   }, []);

//   useEffect(() => {
//     if (!teamId) return;
//     // getTeam returns { team, members } — members is top-level
//     api.get(`/teams/${teamId}`).then(r => setMembers(r.data.members||[])).catch(()=>{});
//   }, [teamId]);

//   const save = async () => {
//     if (!assignTo) { toast.error('Select a member'); return; }
//     setSaving(true);
//     try {
//       // transferLead expects { assignmentId, newAssignedTo, note }
//       await api.post('/teams/transfer', { assignmentId: lead.assignment_id || lead.id, transferTo: assignTo, note });
//       toast.success('Lead reassigned!');
//       onDone(); onClose();
//     } catch(err) { toast.error(err.response?.data?.message || 'Failed to reassign'); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
//       <div className="modal modal-md">
//         <div className="modal-header">
//           <div className="modal-title"><ArrowRightLeft size={15}/> Reassign — {lead.name}</div>
//           <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
//         </div>
//         <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
//           <div className="form-group">
//             <label className="form-label">Team</label>
//             <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
//               <option value="">Select team…</option>
//               {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
//             </select>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Reassign To</label>
//             <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
//               <option value="">Select member…</option>
//               {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
//             </select>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Note</label>
//             <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Reason for reassigning…" style={{minHeight:60}}/>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
//           <button className="btn btn-primary" onClick={save} disabled={saving||!assignTo}>
//             {saving ? 'Reassigning…' : <><ArrowRightLeft size={13}/> Reassign</>}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Lead Row (shared for saved + assigned) ────────────────────────────────
// function LeadRow({ lead, isAssigned, onEdit, onDelete, onAssign, onReassign, onDetail, toggleSel, selected }) {
//   return (
//     <tr key={lead.id}>
//       <td>
//         {!isAssigned && (
//           <input type="checkbox" className="table-checkbox"
//             checked={selected?.includes(lead.id)} onChange={()=>toggleSel(lead.id)}/>
//         )}
//       </td>
//       <td>
//         <div style={{ fontWeight:600, fontSize:13.5, color:'var(--text)', marginBottom:3 }}>{lead.name}</div>
//         {lead.address && (
//           <div style={{ fontSize:12, color:'var(--text3)', display:'flex', alignItems:'center', gap:4 }}>
//             <MapPin size={10}/>{lead.address.substring(0,50)}{lead.address.length>50?'…':''}
//           </div>
//         )}
//       </td>
//       <td>
//         {lead.phone && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
//           <Phone size={11} style={{color:'var(--accent)'}}/><a href={`tel:${lead.phone}`} style={{color:'var(--accent)'}}>{lead.phone}</a>
//         </div>}
//         {lead.email && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
//           <Mail size={11} style={{color:'var(--accent)'}}/><a href={`mailto:${lead.email}`} style={{color:'var(--accent)',overflow:'hidden',textOverflow:'ellipsis',maxWidth:160,display:'block'}}>{lead.email}</a>
//         </div>}
//         {lead.website && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12 }}>
//           <Globe size={11} style={{color:'var(--accent)'}}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',maxWidth:140,overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a>
//         </div>}
//       </td>
//       <td>
//         {lead.rating ? <div style={{ display:'flex', alignItems:'center', gap:4, fontWeight:600, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/>{Number(lead.rating).toFixed(1)}</div> : <span style={{color:'var(--text3)'}}>—</span>}
//       </td>
//       <td>
//         <div style={{ display:'flex', alignItems:'center', gap:6 }}>
//           <div className="score-track" style={{width:50}}>
//             <div className={`score-fill ${(lead.lead_score||0)>=70?'high':(lead.lead_score||0)>=40?'mid':'low'}`} style={{width:`${lead.lead_score||0}%`}}/>
//           </div>
//           <span style={{ fontSize:12, fontWeight:700, color:(lead.lead_score||0)>=70?'var(--green)':(lead.lead_score||0)>=40?'var(--gold)':'var(--red)' }}>{lead.lead_score||0}</span>
//         </div>
//       </td>
//       <td>
//         {isAssigned ? (
//           <select className="select" style={{width:110,height:28,fontSize:12}}
//             value={lead.status||'pending'}
//             onChange={async e => {
//               try {
//                 await api.put(`/teams/assignments/${lead.assignment_id || lead.id}`, { status: e.target.value });
//                 lead.status = e.target.value;
//                 toast.success('Status updated');
//               } catch { toast.error('Failed to update'); }
//             }}>
//             {['pending','in_progress','converted','lost'].map(s=>(
//               <option key={s} value={s}>{s.replace('_',' ').replace(/^\w/,c=>c.toUpperCase())}</option>
//             ))}
//           </select>
//         ) : (
//           <span className={`badge ${STATUS_COLORS[lead.status]||'badge-gray'}`}><span className="badge-dot"/>{lead.status||'new'}</span>
//         )}
//       </td>
//       <td>
//         <span className={`badge ${PRIORITY_COLORS[lead.priority]||'badge-gray'}`}>
//           {lead.priority||'medium'}
//         </span>
//       </td>
//       <td>
//         {isAssigned ? (
//           <div style={{ fontSize:12, color:'var(--text2)' }}>
//             <div>{lead.assigned_by_name}</div>
//             {lead.team_name && <div style={{color:'var(--text3)',fontSize:11}}>{lead.team_name}</div>}
//           </div>
//         ) : (
//           <div style={{ fontSize:12, color:'var(--text2)' }}>
//             <div>{lead.list_name||'Default'}</div>
//             {lead.assigned_to_name && <div style={{ color:'var(--accent)', fontSize:11, marginTop:2 }}>→ {lead.assigned_to_name}</div>}
//           </div>
//         )}
//       </td>
//       <td>
//         {lead.follow_up_date ? (
//           <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12, color:new Date(lead.follow_up_date)<new Date()?'var(--red)':'var(--text2)' }}>
//             <Calendar size={11}/>{new Date(lead.follow_up_date).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}
//           </div>
//         ) : <span style={{color:'var(--text3)'}}>—</span>}
//       </td>
//       <td>
//         <div style={{ display:'flex', gap:4 }}>
//           <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDetail(lead)} title="View details"><MessageSquare size={13}/></button>
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onEdit(lead)} title="Edit"><Edit3 size={13}/></button>}
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onAssign(lead)} title="Assign to team member"><Send size={13}/></button>}
//           {isAssigned  && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onReassign(lead)} title="Reassign"><ArrowRightLeft size={13}/></button>}
//           {lead.google_maps_url && <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-icon btn-sm" title="View on Map"><ExternalLink size={13}/></a>}
//           {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDelete(lead.id)} title="Remove" style={{color:'var(--red)'}}><Trash2 size={13}/></button>}
//         </div>
//       </td>
//     </tr>
//   );
// }

// // ── Main Page ─────────────────────────────────────────────────────────────
// export default function SavedLeadsPage() {
//   const [tab,        setTab]       = useState('saved');   // 'saved' | 'assigned'
//   const [leads,      setLeads]     = useState([]);
//   const [total,      setTotal]     = useState(0);
//   const [loading,    setLoading]   = useState(true);
//   const [search,     setSearch]    = useState('');
//   const [statusF,    setStatusF]   = useState('');
//   const [priorityF,  setPriorityF] = useState('');
//   const [listF,      setListF]     = useState('');
//   const [page,       setPage]      = useState(1);
//   const [editLead,     setEditLead]    = useState(null);
//   const [showAdd,      setShowAdd]     = useState(false);
//   const [assignLead,   setAssignLead]  = useState(null);
//   const [reassignLead, setReassignLead]= useState(null);
//   const [detailLead,   setDetailLead] = useState(null);
//   const [selected,     setSelected]   = useState([]);
//   const PER = 20;

//   const load = async (pg=1) => {
//     setLoading(true);
//     try {
//       const endpoint = tab === 'assigned' ? '/leads/assigned' : '/leads/saved';
//       const params   = { page:pg, limit:PER };
//       if (tab === 'saved') {
//         if (search)    params.search   = search;
//         if (statusF)   params.status   = statusF;
//         if (priorityF) params.priority = priorityF;
//         if (listF)     params.list     = listF;
//       } else {
//         if (statusF)   params.status   = statusF;
//         if (priorityF) params.priority = priorityF;
//       }
//       const r = await api.get(endpoint, { params });
//       setLeads(r.data.leads||[]);
//       setTotal(r.data.total||0);
//       setPage(pg);
//     } catch { toast.error('Failed to load leads'); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => { load(1); }, [tab, statusF, priorityF, listF]);

//   const updateLead = async (id, data) => {
//     await api.put(`/leads/saved/${id}`, { status:data.status, priority:data.priority, notes:data.notes, listName:data.listName, followUpDate:data.followUpDate||null });
//     toast.success('Lead updated'); load(page);
//   };
//   const deleteLead = async (id) => {
//     if (!window.confirm('Remove this lead?')) return;
//     await api.delete(`/leads/saved/${id}`); toast.success('Removed'); load(page);
//   };
//   const deleteSelected = async () => {
//     if (!window.confirm(`Delete ${selected.length} leads?`)) return;
//     await Promise.all(selected.map(id => api.delete(`/leads/saved/${id}`).catch(()=>{})));
//     setSelected([]); toast.success(`${selected.length} leads removed`); load(1);
//   };
//   const exportCSV = () => {
//     const rows = selected.length>0 ? leads.filter(l=>selected.includes(l.id)) : leads;
//     const cols = ['name','address','phone','email','website','rating','lead_score','status','priority','list_name','notes'];
//     const csv  = [cols.join(','), ...rows.map(l=>cols.map(c=>`"${(l[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
//     const a = document.createElement('a'); a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'})); a.download='saved_leads.csv'; a.click();
//     toast.success(`Exported ${rows.length} leads`);
//   };
//   const toggleSel   = id => setSelected(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);
//   const totalPages  = Math.ceil(total/PER);
//   const lists       = [...new Set(leads.map(l=>l.list_name).filter(Boolean))];

//   return (
//     <div style={{ maxWidth:1300, margin:'0 auto', padding:'24px' }}>

//       {/* Header */}
//       <div className="flex-between mb-20">
//         <div>
//           <h1 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:800, marginBottom:4 }}>Saved Leads</h1>
//           <p style={{ color:'var(--text3)', fontSize:14 }}>{total.toLocaleString()} leads</p>
//         </div>
//         <div style={{ display:'flex', gap:8 }}>
//           {tab==='saved' && selected.length>0 && (
//             <button className="btn btn-danger btn-sm" onClick={deleteSelected}><Trash2 size={13}/> Delete ({selected.length})</button>
//           )}
//           {tab==='saved' && (
//             <>
//               <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead</button>
//               <button className="btn btn-success btn-sm" onClick={exportCSV}><Download size={13}/> Export {selected.length>0?`(${selected.length})`:'CSV'}</button>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Tabs */}
//       <div style={{ display:'flex', gap:4, marginBottom:16, borderBottom:'2px solid var(--border)', paddingBottom:0 }}>
//         {[
//           { id:'saved',    label:'My Saved Leads', icon:<Bookmark size={14}/> },
//           { id:'assigned', label:'Assigned to Me',  icon:<UserCheck size={14}/> },
//         ].map(t=>(
//           <button key={t.id} onClick={()=>{setTab(t.id);setStatusF('');setPriorityF('');setSelected([]);}}
//             style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 16px', borderRadius:'8px 8px 0 0',
//               border:'none', cursor:'pointer', fontSize:13.5, fontWeight:tab===t.id?700:500,
//               background:tab===t.id?'var(--surface)':'transparent',
//               color:tab===t.id?'var(--accent)':'var(--text3)',
//               borderBottom:tab===t.id?'2px solid var(--accent)':'2px solid transparent',
//               marginBottom:-2 }}>
//             {t.icon}{t.label}
//           </button>
//         ))}
//       </div>

//       {/* Filters */}
//       <div className="toolbar mb-16">
//         <div className="toolbar-left">
//           {tab==='saved' && (
//             <div className="input-group" style={{minWidth:220}}>
//               <Search size={14} className="input-icon"/>
//               <input className="input" placeholder="Search leads…" value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load(1)}/>
//             </div>
//           )}
//           <select className="select" style={{width:140}} value={statusF} onChange={e=>setStatusF(e.target.value)}>
//             <option value="">All Statuses</option>
//             {STATUS_OPTS.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
//           </select>
//           <select className="select" style={{width:130}} value={priorityF} onChange={e=>setPriorityF(e.target.value)}>
//             <option value="">All Priorities</option>
//             {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//           </select>
//           {tab==='saved' && lists.length>0 && (
//             <select className="select" style={{width:150}} value={listF} onChange={e=>setListF(e.target.value)}>
//               <option value="">All Lists</option>
//               {lists.map(l=><option key={l} value={l}>{l}</option>)}
//             </select>
//           )}
//         </div>
//         {tab==='saved' && (
//           <div className="toolbar-right">
//             <button className="btn btn-ghost btn-sm" onClick={()=>leads.length===selected.length?setSelected([]):setSelected(leads.map(l=>l.id))}>
//               {leads.length===selected.length?'Deselect All':'Select All'}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Status Summary — saved tab only */}
//       {tab==='saved' && (
//         <div className="grid-stats mb-16">
//           {STATUS_OPTS.map(s => {
//             const count = leads.filter(l=>l.status===s).length;
//             return (
//               <div key={s} className="card card-sm" style={{ cursor:'pointer', border:statusF===s?'2px solid var(--accent)':'1px solid var(--border)' }}
//                 onClick={()=>setStatusF(statusF===s?'':s)}>
//                 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
//                   <span className={`badge ${STATUS_COLORS[s]}`}><span className="badge-dot"/>{s.charAt(0).toUpperCase()+s.slice(1)}</span>
//                   <span style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:800 }}>{count}</span>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* Table — saved tab only */}
//       {loading ? (
//         <div className="empty-state"><div className="spinner spinner-lg"/></div>
//       ) : leads.length===0 ? (
//         <div className="empty-state">
//           <div className="empty-icon">{tab==='assigned'?<UserCheck size={26}/>:<Bookmark size={26}/>}</div>
//           <div className="empty-title">{tab==='assigned'?'No leads assigned to you':'No saved leads yet'}</div>
//           <div className="empty-sub">
//             {tab==='assigned'
//               ? 'When a team member assigns a lead to you, it will appear here.'
//               : 'Search for businesses and save the ones you want to follow up with.'}
//           </div>
//           {tab==='saved' && <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead Manually</button>}
//         </div>

//       ) : tab==='saved' ? (
//         <>
//           <div className="table-wrap">
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th><input type="checkbox" className="table-checkbox" checked={selected.length===leads.length&&leads.length>0} onChange={e=>e.target.checked?setSelected(leads.map(l=>l.id)):setSelected([])}/></th>
//                   <th>Business</th>
//                   <th>Contact</th>
//                   <th>Rating</th>
//                   <th>Score</th>
//                   <th>Status</th>
//                   <th>Priority</th>
//                   <th>List / Assigned</th>
//                   <th>Follow-up</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {leads.map(lead=>(
//                   <LeadRow key={lead.id} lead={lead} isAssigned={false}
//                     onEdit={setEditLead} onDelete={deleteLead}
//                     onAssign={setAssignLead} onReassign={setReassignLead}
//                     onDetail={setDetailLead}
//                     toggleSel={toggleSel} selected={selected}/>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           {totalPages>1 && (
//             <div className="pagination mt-16">
//               <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
//               <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
//               <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
//             </div>
//           )}
//         </>

//       ) : (
//         /* ── Assigned tab — exact same card UI as TeamPage MyAssignedLeads ── */
//         <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
//           {leads.map(lead => (
//             <div key={lead.id} className="card" style={{ padding:'14px 16px', borderLeft:`3px solid ${priColor(lead.priority)}` }}>
//               <div style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:10 }}>
//                 <div style={{ flex:1, minWidth:0 }}>
//                   <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:5 }}>
//                     <div style={{ fontWeight:700, fontSize:14 }}>{lead.name}</div>
//                     <span className={`badge ${statusBadge(lead.status)}`}><span className="badge-dot"/>{statusLabel(lead.status)}</span>
//                     {lead.priority && <span style={{ fontSize:11, fontWeight:700, color:priColor(lead.priority) }}>● {lead.priority}</span>}
//                     {isOverdue(lead.due_date) && <span className="badge badge-red"><AlertTriangle size={9}/>Overdue</span>}
//                   </div>
//                   <div style={{ display:'flex', gap:14, fontSize:12.5, color:'var(--text3)', flexWrap:'wrap' }}>
//                     {lead.phone && <span>📞 {lead.phone}</span>}
//                     {lead.team_name && <span>👥 {lead.team_name}</span>}
//                     {lead.due_date && <span style={{ color:isOverdue(lead.due_date)?'var(--red)':'var(--text3)' }}>📅 {fmtDate(lead.due_date)}</span>}
//                     {lead.assigned_by_name && <span>By {lead.assigned_by_name}</span>}
//                     {lead.last_comment && <span style={{ fontStyle:'italic' }}>💬 {lead.last_comment.substring(0,40)}{lead.last_comment.length>40?'…':''}</span>}
//                   </div>
//                 </div>
//                 <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>setDetailLead(lead)} title="Comments & details">
//                   <MessageSquare size={14}/>
//                 </button>
//               </div>
//               {lead.note && <div style={{ fontSize:12.5, background:'var(--bg3)', borderRadius:7, padding:'6px 10px', marginBottom:10, color:'var(--text2)' }}>💬 {lead.note}</div>}
//               {/* Quick status buttons — exact same as TeamPage */}
//               <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
//                 {STATUSES.map(s => (
//                   <button key={s.value}
//                     className={`badge ${s.cls}`}
//                     style={{ cursor:'pointer', padding:'4px 9px', fontSize:11.5, border:`2px solid ${lead.status===s.value?'currentColor':'transparent'}`, opacity:lead.status===s.value?1:0.55, transition:'opacity .15s' }}
//                     onClick={async () => {
//                       try {
//                         await api.put(`/teams/assignments/${lead.assignment_id}`, { status: s.value });
//                         setLeads(prev => prev.map(l => l.assignment_id===lead.assignment_id ? {...l, status:s.value} : l));
//                         toast.success(`→ ${s.label}`);
//                       } catch { toast.error('Failed to update'); }
//                     }}>
//                     {lead.status===s.value && <Check size={9}/>}{s.label}
//                   </button>
//                 ))}
//                 <button className="btn btn-ghost btn-sm" style={{ marginLeft:'auto', fontSize:12 }} onClick={()=>setReassignLead(lead)}>
//                   <ArrowRightLeft size={12}/> Reassign
//                 </button>
//                 {lead.google_maps_url && (
//                   <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm" style={{ textDecoration:'none', fontSize:12 }}>
//                     <ExternalLink size={12}/>
//                   </a>
//                 )}
//               </div>
//             </div>
//           ))}
//           {totalPages>1 && (
//             <div className="pagination mt-16">
//               <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
//               <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
//               <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
//             </div>
//           )}
//         </div>
//       )}

//       {editLead    && <EditModal lead={editLead} onClose={()=>setEditLead(null)} onSave={updateLead}/>}
//       {showAdd     && <AddLeadModal onClose={()=>setShowAdd(false)} onAdded={()=>load(1)}/>}
//       {assignLead  && <AssignModal lead={assignLead} onClose={()=>setAssignLead(null)} onDone={()=>load(page)}/>}
//       {reassignLead && <ReassignModal lead={reassignLead} onClose={()=>setReassignLead(null)} onDone={()=>load(page)}/>}
//       {detailLead  && <LeadPanel lead={detailLead} isAssigned={tab==='assigned'} onClose={()=>setDetailLead(null)} onRefresh={()=>load(page)}/>}
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Bookmark, Search, Download, Trash2, Edit3, X, Star, Phone, Globe,
  ExternalLink, MapPin, ChevronLeft, ChevronRight, Calendar, Plus,
  UserCheck, Mail, Send, ArrowRightLeft, MessageSquare, Check, Clock,
  AlertTriangle, RefreshCw } from 'lucide-react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const STATUS_OPTS    = ['new','contacted','qualified','converted','lost'];
const PRIORITY_OPTS  = ['low','medium','high','urgent'];
const STATUS_COLORS  = { new:'badge-blue', contacted:'badge-gold', qualified:'badge-purple', converted:'badge-green', lost:'badge-red' };
const PRIORITY_COLORS= { low:'badge-gray', medium:'badge-blue', high:'badge-gold', urgent:'badge-red' };

const STATUSES = [
  { value:'pending',     label:'Pending',     cls:'badge-gray'   },
  { value:'in_progress', label:'In Progress', cls:'badge-blue'   },
  { value:'contacted',   label:'Contacted',   cls:'badge-gold'   },
  { value:'qualified',   label:'Qualified',   cls:'badge-purple' },
  { value:'converted',   label:'Converted',   cls:'badge-green'  },
  { value:'lost',        label:'Lost',        cls:'badge-red'    },
];
const statusLabel = s => STATUSES.find(x=>x.value===s)?.label || STATUS_OPTS.find(x=>x===s) || s || '—';
const statusBadge = s => STATUSES.find(x=>x.value===s)?.cls || STATUS_COLORS[s] || 'badge-gray';
const priColor    = p => ({ urgent:'#ef4444', high:'#f97316', medium:'#f59e0b', low:'#94a3b8' }[p] || '#94a3b8');
const fmtDate     = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'}) : '—';
const isOverdue   = d => d && new Date(d) < new Date();

// ── Lead Detail Side Panel (from TeamPage) ────────────────────────────────
function LeadPanel({ lead, isAssigned, onClose, onRefresh }) {
  const { user }               = useAuth();
  const [comments, setComments]= useState([]);
  const [activity, setActivity]= useState([]);
  const [newComment, setComment]= useState('');
  const [posting, setPosting]  = useState(false);
  const [tab, setTab]          = useState('details');
  const [stLd, setStLd]        = useState(false);
  const bottomRef              = useRef(null);

  const savedLeadId = lead.saved_lead_id || lead.id;
  const teamId      = lead.team_id || '';
  const assignmentId = lead.assignment_id || '';

  const loadComments = useCallback(async () => {
    try {
      if (isAssigned && teamId) {
        // Assigned lead — use team comments API
        const [cr, ar] = await Promise.all([
          api.get('/teams/comments', { params:{ savedLeadId, teamId } }),
          api.get('/teams/activity',  { params:{ savedLeadId, teamId } }),
        ]);
        setComments(cr.data.comments||[]);
        setActivity(ar.data.activity||[]);
      } else {
        // Saved lead — use personal comments API
        const r = await api.get(`/leads/saved/${lead.id}/comments`);
        setComments(r.data.comments||[]);
      }
    } catch {}
  }, [savedLeadId, teamId, lead.id, isAssigned]);

  const postComment = async e => {
    e.preventDefault();
    if (!newComment.trim()) return;
    setPosting(true);
    try {
      if (isAssigned && teamId) {
        const r = await api.post('/teams/comments', { savedLeadId, teamId, comment: newComment.trim() });
        setComments(c => [...c, r.data.comment]);
      } else {
        const r = await api.post(`/leads/saved/${lead.id}/comments`, { comment: newComment.trim() });
        setComments(c => [...c, r.data.comment]);
      }
      setComment('');
    } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setPosting(false); }
  };

  const delComment = async id => {
    try {
      if (isAssigned && teamId) {
        await api.delete(`/teams/comments/${id}`);
      } else {
        await api.delete(`/leads/saved/${lead.id}/comments/${id}`);
      }
      setComments(c => c.filter(x=>x.id!==id));
    } catch { toast.error('Failed'); }
  };

  useEffect(() => { loadComments(); }, [loadComments]);
  useEffect(() => { if (tab==='comments') bottomRef.current?.scrollIntoView({ behavior:'smooth' }); }, [comments, tab]);

  const [localStatus, setLocalStatus] = useState(lead.status || 'new');

  const changeStatus = async newStatus => {
    setStLd(true);
    try {
      if (isAssigned && assignmentId) {
        await api.put(`/teams/assignments/${assignmentId}`, { status: newStatus });
      } else {
        await api.put(`/leads/saved/${lead.id}`, { status: newStatus });
      }
      setLocalStatus(newStatus);
      toast.success(`→ ${newStatus}`);
      onRefresh();
    } catch(err) { toast.error('Failed to update status'); }
    finally { setStLd(false); }
  };

  return (
    <>
      <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:199 }} onClick={onClose}/>
      <div style={{ position:'fixed', top:0, right:0, bottom:0, width:'min(480px,100vw)', background:'var(--surface)', borderLeft:'1px solid var(--border)', zIndex:200, display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,.2)', overflowY:'auto' }}>

        {/* Header */}
        <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'flex-start', gap:10, position:'sticky', top:0, background:'var(--surface)', zIndex:1 }}>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>{lead.name}</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
              <span className={`badge ${statusBadge(localStatus)}`}><span className="badge-dot"/>{statusLabel(localStatus)}</span>
              {lead.priority && <span style={{ fontSize:11.5, fontWeight:700, color:priColor(lead.priority) }}>● {lead.priority}</span>}
              {lead.follow_up_date && <span style={{ fontSize:11.5, color:isOverdue(lead.follow_up_date)?'var(--red)':'var(--text3)' }}>📅 {fmtDate(lead.follow_up_date)}</span>}
            </div>
          </div>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={15}/></button>
        </div>

        {/* Contact */}
        <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)', display:'flex', flexDirection:'column', gap:6 }}>
          {lead.phone   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Phone size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`tel:${lead.phone}`} style={{ color:'var(--text2)', textDecoration:'none' }}>{lead.phone}</a></div>}
          {lead.email   && <div style={{ display:'flex', gap:8, fontSize:13 }}><Mail size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={`mailto:${lead.email}`} style={{ color:'var(--accent)', textDecoration:'none' }}>{lead.email}</a></div>}
          {lead.website && <div style={{ display:'flex', gap:8, fontSize:13 }}><Globe size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:1 }}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{ color:'var(--accent)', textDecoration:'none', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a></div>}
          {lead.address && <div style={{ display:'flex', gap:8, fontSize:12.5, color:'var(--text3)' }}><MapPin size={13} style={{ flexShrink:0, marginTop:1 }}/>{lead.address}</div>}
          {/* Owner / assigned info */}
          {lead.list_name && !isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>📋 List: <strong style={{ color:'var(--text)' }}>{lead.list_name}</strong></div>}
          {lead.assigned_to_name && !isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👤 Assigned to: <strong style={{ color:'var(--accent)' }}>{lead.assigned_to_name}</strong></div>}
          {lead.assigned_by_name && isAssigned && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👤 Assigned by: <strong style={{ color:'var(--text)' }}>{lead.assigned_by_name}</strong></div>}
          {lead.team_name && <div style={{ fontSize:12.5, color:'var(--text3)' }}>👥 Team: <strong style={{ color:'var(--text)' }}>{lead.team_name}</strong></div>}
          {lead.rating && <div style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/><strong>{Number(lead.rating).toFixed(1)}</strong><span style={{ color:'var(--text3)', fontSize:12 }}>({lead.review_count||0} reviews)</span></div>}
          {lead.lead_score > 0 && <div style={{ fontSize:12.5, color:'var(--text3)' }}>🎯 Lead Score: <strong style={{ color:'var(--text)' }}>{lead.lead_score}</strong></div>}
        </div>

        {/* Status change — all leads */}
        <div style={{ padding:'12px 20px', borderBottom:'1px solid var(--border)' }}>
          <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>Update Status</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {(isAssigned ? STATUSES : [
              { value:'new',       label:'New',       cls:'badge-blue'   },
              { value:'contacted', label:'Contacted', cls:'badge-gold'   },
              { value:'qualified', label:'Qualified', cls:'badge-purple' },
              { value:'converted', label:'Converted', cls:'badge-green'  },
              { value:'lost',      label:'Lost',      cls:'badge-red'    },
            ]).map(s => (
              <button key={s.value} onClick={() => changeStatus(s.value)} disabled={stLd}
                className={`badge ${s.cls}`}
                style={{ cursor:'pointer', padding:'5px 11px', border:`2px solid ${localStatus===s.value?'currentColor':'transparent'}`, fontSize:12, opacity:localStatus===s.value?1:0.6, transition:'all .15s' }}>
                {localStatus===s.value && <Check size={10}/>}{s.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display:'flex', borderBottom:'1px solid var(--border)', padding:'0 20px' }}>
          {[['details','📋 Details'], ['comments',`💬 Comments (${comments.length})`], ...(teamId?[['activity','📋 Activity']]:[])]
            .map(([v,l]) => (
              <button key={v} onClick={() => { setTab(v); if(v==='comments'||v==='activity') loadComments(); }}
                style={{ padding:'10px 14px', border:'none', background:'none', fontWeight:tab===v?700:500, fontSize:13, color:tab===v?'var(--accent)':'var(--text3)', cursor:'pointer', borderBottom:tab===v?'2px solid var(--accent)':'2px solid transparent', marginBottom:-1 }}>
                {l}
              </button>
            ))
          }
        </div>

        {/* Details tab */}
        {tab==='details' && (
          <div style={{ padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
            {lead.notes && (
              <div style={{ background:'var(--bg3)', borderRadius:8, padding:'10px 14px', fontSize:13.5, color:'var(--text2)', lineHeight:1.6 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'var(--text3)', marginBottom:6, textTransform:'uppercase', letterSpacing:.8 }}>Notes</div>
                {lead.notes}
              </div>
            )}
            {lead.google_maps_url && (
              <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-full" style={{ textDecoration:'none', justifyContent:'center' }}>
                <ExternalLink size={13}/> View on Map
              </a>
            )}
          </div>
        )}

        {/* Comments tab */}
        {tab==='comments' && (
          <div style={{ flex:1, display:'flex', flexDirection:'column' }}>
            {!teamId ? (
              <div style={{ flex:1, padding:'32px 20px', textAlign:'center', color:'var(--text3)', fontSize:13 }}>
                <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
                <div>Comments are available for team-assigned leads only.</div>
                <div style={{ fontSize:12, marginTop:6 }}>Assign this lead to a team member to enable comments.</div>
              </div>
            ) : (
              <>
                <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
                  {comments.length===0 && (
                    <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
                      <MessageSquare size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/>
                      <div>No comments yet</div>
                    </div>
                  )}
                  {comments.map(c => (
                    <div key={c.id} style={{ display:'flex', gap:10 }}>
                      <div style={{ width:32, height:32, borderRadius:'50%', background:'linear-gradient(135deg,var(--accent),var(--accent2))', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:12, fontWeight:700, flexShrink:0 }}>
                        {c.first_name?.[0]}{c.last_name?.[0]}
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                          <span style={{ fontWeight:600, fontSize:13 }}>{c.first_name} {c.last_name}</span>
                          <span style={{ fontSize:11, color:'var(--text3)' }}>{new Date(c.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</span>
                          {c.user_id===user?.id && <button onClick={()=>delComment(c.id)} style={{ marginLeft:'auto', background:'none', border:'none', color:'var(--text3)', cursor:'pointer', padding:2, display:'flex', borderRadius:4 }}><Trash2 size={11}/></button>}
                        </div>
                        <div style={{ background:'var(--bg3)', borderRadius:'4px 12px 12px 12px', padding:'8px 12px', fontSize:13.5, lineHeight:1.5, wordBreak:'break-word' }}>{c.comment}</div>
                      </div>
                    </div>
                  ))}
                  <div ref={bottomRef}/>
                </div>
                <div style={{ padding:'12px 20px', borderTop:'1px solid var(--border)' }}>
                  <form onSubmit={postComment} style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
                    <textarea className="textarea" style={{ flex:1, minHeight:40, maxHeight:100, resize:'none', fontSize:13.5 }}
                      placeholder="Add a comment… (Enter to send)"
                      value={newComment} onChange={e=>setComment(e.target.value)}
                      onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();postComment(e);} }}/>
                    <button type="submit" className="btn btn-primary" style={{ padding:'8px 12px', flexShrink:0 }} disabled={posting||!newComment.trim()}>
                      {posting?<div className="spinner spinner-sm"/>:<Send size={14}/>}
                    </button>
                  </form>
                </div>
              </>
            )}
          </div>
        )}

        {/* Activity tab */}
        {tab==='activity' && teamId && (
          <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12 }}>
            {activity.length===0 && (
              <div style={{ textAlign:'center', color:'var(--text3)', fontSize:13, padding:'32px 0' }}>
                <Clock size={28} style={{ margin:'0 auto 10px', opacity:.4 }}/><div>No activity yet</div>
              </div>
            )}
            {activity.map(a => (
              <div key={a.id} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                <div style={{ width:28, height:28, borderRadius:'50%', background:'var(--bg3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>
                  {({assigned:'🎯',transferred:'↔️',status_changed:'🔄',comment_added:'💬'}[a.action]||'📋')}
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:13, color:'var(--text2)', lineHeight:1.5 }}>
                    <strong>{a.first_name} {a.last_name}</strong>{' '}
                    {a.action==='assigned' && 'assigned this lead'}
                    {a.action==='transferred' && 'transferred this lead'}
                    {a.action==='status_changed' && <><span style={{ color:'var(--text3)' }}>changed status to </span><strong>{statusLabel(a.new_value)}</strong></>}
                    {a.action==='comment_added' && 'added a comment'}
                  </div>
                  {a.note && a.action!=='comment_added' && <div style={{ fontSize:12, color:'var(--text3)', fontStyle:'italic', marginTop:2 }}>"{a.note}"</div>}
                  <div style={{ fontSize:11, color:'var(--text3)', marginTop:3 }}>{new Date(a.created_at).toLocaleString('en-IN',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

// ── Edit Modal ────────────────────────────────────────────────────────────
function EditModal({ lead, onClose, onSave }) {
  const [form, setForm] = useState({
    status: lead.status||'new', priority: lead.priority||'medium',
    notes: lead.notes||'', listName: lead.list_name||'Default',
    followUpDate: lead.follow_up_date?.split('T')[0]||''
  });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await onSave(lead.id, form); onClose(); }
    catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div className="modal-title">Edit Lead — {lead.name}</div>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">CRM Status</label>
              <select className="select" value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>
                {STATUS_OPTS.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Priority</label>
              <select className="select" value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))}>
                {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">List Name</label>
              <input className="input" value={form.listName} onChange={e=>setForm(f=>({...f,listName:e.target.value}))} placeholder="Default"/>
            </div>
            <div className="form-group">
              <label className="form-label">Follow-up Date</label>
              <input className="input" type="date" value={form.followUpDate} onChange={e=>setForm(f=>({...f,followUpDate:e.target.value}))}/>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Notes</label>
            <textarea className="textarea" value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Add notes…"/>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
        </div>
      </div>
    </div>
  );
}

// ── Add Lead Modal ────────────────────────────────────────────────────────
function AddLeadModal({ onClose, onAdded }) {
  const [form, setForm] = useState({
    name:'', address:'', phone:'', email:'', website:'', businessType:'',
    listName:'Default', priority:'medium', notes:''
  });
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:''})); };

  const BUSINESS_TYPES = [
    'restaurant','cafe','hospital','clinic','school','college','hotel','gym',
    'pharmacy','bank','real_estate_agency','lawyer','accountant','beauty_salon',
    'clothing_store','electronics_store','grocery_store','retail','spa',
    'marketing_agency','software_company','construction_company','other'
  ];

  const save = async () => {
    const e = {};
    if (!form.name.trim())         e.name         = 'Business name is required';
    if (!form.businessType.trim()) e.businessType = 'Business type is required';
    setErrors(e); if (Object.keys(e).length) return;
    setSaving(true);
    try {
      await api.post('/leads/add', form);
      toast.success('Lead added!');
      onAdded();
      onClose();
    } catch(err) { toast.error(err.response?.data?.message || 'Failed to add lead'); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div className="modal-title"><Plus size={16}/> Add Lead Manually</div>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
          <div className="form-group">
            <label className="form-label">Business Name *</label>
            <input className={`input${errors.name?' input-error':''}`} value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. ABC Enterprises"/>
            {errors.name && <div className="form-error">{errors.name}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">Business Type *</label>
            <select className={`select${errors.businessType?' input-error':''}`} value={form.businessType} onChange={e=>set('businessType',e.target.value)}>
              <option value="">Select business type…</option>
              {BUSINESS_TYPES.map(t=><option key={t} value={t}>{t.replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase())}</option>)}
            </select>
            {errors.businessType && <div className="form-error">{errors.businessType}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">Address</label>
            <input className="input" value={form.address} onChange={e=>set('address',e.target.value)} placeholder="Full address"/>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input className="input" value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+91 98765 43210"/>
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="input" type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="info@business.com"/>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Website</label>
            <input className="input" value={form.website} onChange={e=>set('website',e.target.value)} placeholder="https://business.com"/>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">List Name</label>
              <input className="input" value={form.listName} onChange={e=>set('listName',e.target.value)} placeholder="Default"/>
            </div>
            <div className="form-group">
              <label className="form-label">Priority</label>
              <select className="select" value={form.priority} onChange={e=>set('priority',e.target.value)}>
                {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Notes</label>
            <textarea className="textarea" value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Add notes about this lead…"/>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? 'Adding…' : <><Plus size={13}/> Add Lead</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Assign Lead Modal ─────────────────────────────────────────────────────
function AssignModal({ lead, onClose, onDone }) {
  const [teams,    setTeams]    = useState([]);
  const [members,  setMembers]  = useState([]);
  const [teamId,   setTeamId]   = useState('');
  const [assignTo, setAssignTo] = useState('');
  const [note,     setNote]     = useState('');
  const [dueDate,  setDueDate]  = useState('');
  const [priority, setPriority] = useState('medium');
  const [saving,   setSaving]   = useState(false);
  const [loadingT, setLoadingT] = useState(true);

  useEffect(() => {
    api.get('/teams').then(r => {
      const teamList = r.data.teams || [];
      setTeams(teamList);
      if (teamList.length === 1) setTeamId(teamList[0].id);
    }).catch(()=>{}).finally(()=>setLoadingT(false));
  }, []);

  useEffect(() => {
    if (!teamId) { setMembers([]); setAssignTo(''); return; }
    // getTeam returns { team, members } — members is top-level
    api.get(`/teams/${teamId}`).then(r => {
      setMembers(r.data.members || []);
    }).catch(()=>{});
  }, [teamId]);

  const save = async () => {
    if (!teamId)   { toast.error('Select a team'); return; }
    if (!assignTo) { toast.error('Select a member'); return; }
    setSaving(true);
    try {
      await api.post('/teams/assign', { savedLeadId: lead.id, assignedTo: assignTo, teamId, note, dueDate: dueDate||undefined, priority });
      toast.success(`Lead assigned!`);
      onDone(); onClose();
    } catch(err) { toast.error(err.response?.data?.message || 'Failed to assign'); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div className="modal-title"><Send size={15}/> Assign Lead — {lead.name}</div>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
          {loadingT ? <div className="spinner"/> : teams.length === 0 ? (
            <div style={{textAlign:'center',color:'var(--text3)',padding:'20px 0'}}>
              You are not part of any team yet. Join or create a team to assign leads.
            </div>
          ) : (
            <>
              <div className="form-group">
                <label className="form-label">Team</label>
                <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
                  <option value="">Select team…</option>
                  {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Assign To</label>
                <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
                  <option value="">Select member…</option>
                  {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Priority</label>
                  <select className="select" value={priority} onChange={e=>setPriority(e.target.value)}>
                    {['low','medium','high','urgent'].map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Due Date</label>
                  <input className="input" type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Note</label>
                <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Add a note for the assignee…" style={{minHeight:60}}/>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          {teams.length > 0 && (
            <button className="btn btn-primary" onClick={save} disabled={saving||!teamId||!assignTo}>
              {saving ? 'Assigning…' : <><Send size={13}/> Assign</>}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Reassign Lead Modal ───────────────────────────────────────────────────
function ReassignModal({ lead, onClose, onDone }) {
  const [teams,    setTeams]    = useState([]);
  const [members,  setMembers]  = useState([]);
  const [teamId,   setTeamId]   = useState(lead.team_id||'');
  const [assignTo, setAssignTo] = useState('');
  const [note,     setNote]     = useState('');
  const [saving,   setSaving]   = useState(false);

  useEffect(() => {
    api.get('/teams').then(r => { setTeams(r.data.teams||[]); }).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!teamId) return;
    // getTeam returns { team, members } — members is top-level
    api.get(`/teams/${teamId}`).then(r => setMembers(r.data.members||[])).catch(()=>{});
  }, [teamId]);

  const save = async () => {
    if (!assignTo) { toast.error('Select a member'); return; }
    setSaving(true);
    try {
      // transferLead expects { assignmentId, newAssignedTo, note }
      await api.post('/teams/transfer', { assignmentId: lead.assignment_id || lead.id, transferTo: assignTo, note });
      toast.success('Lead reassigned!');
      onDone(); onClose();
    } catch(err) { toast.error(err.response?.data?.message || 'Failed to reassign'); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div className="modal-title"><ArrowRightLeft size={15}/> Reassign — {lead.name}</div>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:14}}>
          <div className="form-group">
            <label className="form-label">Team</label>
            <select className="select" value={teamId} onChange={e=>setTeamId(e.target.value)}>
              <option value="">Select team…</option>
              {teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Reassign To</label>
            <select className="select" value={assignTo} onChange={e=>setAssignTo(e.target.value)} disabled={!teamId}>
              <option value="">Select member…</option>
              {members.map(m=><option key={m.user_id} value={m.user_id}>{m.first_name} {m.last_name} ({m.role})</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Note</label>
            <textarea className="textarea" value={note} onChange={e=>setNote(e.target.value)} placeholder="Reason for reassigning…" style={{minHeight:60}}/>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving||!assignTo}>
            {saving ? 'Reassigning…' : <><ArrowRightLeft size={13}/> Reassign</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Lead Row (shared for saved + assigned) ────────────────────────────────
function LeadRow({ lead, isAssigned, onEdit, onDelete, onAssign, onReassign, onDetail, toggleSel, selected }) {
  return (
    <tr key={lead.id}>
      <td>
        {!isAssigned && (
          <input type="checkbox" className="table-checkbox"
            checked={selected?.includes(lead.id)} onChange={()=>toggleSel(lead.id)}/>
        )}
      </td>
      <td>
        <div style={{ fontWeight:600, fontSize:13.5, color:'var(--text)', marginBottom:3 }}>{lead.name}</div>
        {lead.address && (
          <div style={{ fontSize:12, color:'var(--text3)', display:'flex', alignItems:'center', gap:4 }}>
            <MapPin size={10}/>{lead.address.substring(0,50)}{lead.address.length>50?'…':''}
          </div>
        )}
      </td>
      <td>
        {lead.business_type ? (
          <span style={{ fontSize:11.5, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:4, padding:'2px 7px', color:'var(--text2)', textTransform:'capitalize', whiteSpace:'nowrap' }}>
            {lead.business_type.replace(/_/g,' ')}
          </span>
        ) : <span style={{color:'var(--text3)'}}>—</span>}
      </td>
      <td>
        {lead.phone && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
          <Phone size={11} style={{color:'var(--accent)'}}/><a href={`tel:${lead.phone}`} style={{color:'var(--accent)'}}>{lead.phone}</a>
        </div>}
        {lead.email && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12.5, marginBottom:3 }}>
          <Mail size={11} style={{color:'var(--accent)'}}/><a href={`mailto:${lead.email}`} style={{color:'var(--accent)',overflow:'hidden',textOverflow:'ellipsis',maxWidth:160,display:'block'}}>{lead.email}</a>
        </div>}
        {lead.website && <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12 }}>
          <Globe size={11} style={{color:'var(--accent)'}}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',maxWidth:140,overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a>
        </div>}
      </td>
      <td>
        {lead.rating ? <div style={{ display:'flex', alignItems:'center', gap:4, fontWeight:600, color:'var(--gold)' }}><Star size={12} fill="var(--gold)" stroke="none"/>{Number(lead.rating).toFixed(1)}</div> : <span style={{color:'var(--text3)'}}>—</span>}
      </td>
      <td>
        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
          <div className="score-track" style={{width:50}}>
            <div className={`score-fill ${(lead.lead_score||0)>=70?'high':(lead.lead_score||0)>=40?'mid':'low'}`} style={{width:`${lead.lead_score||0}%`}}/>
          </div>
          <span style={{ fontSize:12, fontWeight:700, color:(lead.lead_score||0)>=70?'var(--green)':(lead.lead_score||0)>=40?'var(--gold)':'var(--red)' }}>{lead.lead_score||0}</span>
        </div>
      </td>
      <td>
        {isAssigned ? (
          <span className={`badge ${statusBadge(lead.status||'pending')}`}><span className="badge-dot"/>{statusLabel(lead.status||'pending')}</span>
        ) : (
          <span className={`badge ${STATUS_COLORS[lead.status]||'badge-gray'}`}><span className="badge-dot"/>{lead.status||'new'}</span>
        )}
      </td>
      <td>
        <span className={`badge ${PRIORITY_COLORS[lead.priority]||'badge-gray'}`}>
          {lead.priority||'medium'}
        </span>
      </td>
      <td>
        {isAssigned ? (
          <div style={{ fontSize:12, color:'var(--text2)' }}>
            <div>{lead.assigned_by_name}</div>
            {lead.team_name && <div style={{color:'var(--text3)',fontSize:11}}>{lead.team_name}</div>}
          </div>
        ) : (
          <div style={{ fontSize:12, color:'var(--text2)' }}>
            <div>{lead.list_name||'Default'}</div>
            {lead.assigned_to_name && <div style={{ color:'var(--accent)', fontSize:11, marginTop:2 }}>→ {lead.assigned_to_name}</div>}
          </div>
        )}
      </td>
      <td>
        {lead.follow_up_date ? (
          <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:12, color:new Date(lead.follow_up_date)<new Date()?'var(--red)':'var(--text2)' }}>
            <Calendar size={11}/>{new Date(lead.follow_up_date).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}
          </div>
        ) : <span style={{color:'var(--text3)'}}>—</span>}
      </td>
      <td>
        <div style={{ display:'flex', gap:4 }}>
          <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDetail(lead)} title="View details"><MessageSquare size={13}/></button>
          {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onEdit(lead)} title="Edit"><Edit3 size={13}/></button>}
          {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onAssign(lead)} title="Assign to team member"><Send size={13}/></button>}
          {isAssigned  && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onReassign(lead)} title="Reassign"><ArrowRightLeft size={13}/></button>}
          {lead.google_maps_url && <a href={lead.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-icon btn-sm" title="View on Map"><ExternalLink size={13}/></a>}
          {!isAssigned && <button className="btn btn-ghost btn-icon btn-sm" onClick={()=>onDelete(lead.id)} title="Remove" style={{color:'var(--red)'}}><Trash2 size={13}/></button>}
        </div>
      </td>
    </tr>
  );
}

// ── Main Page ─────────────────────────────────────────────────────────────
export default function SavedLeadsPage() {
  const [tab,        setTab]       = useState('saved');   // 'saved' | 'assigned'
  const [leads,      setLeads]     = useState([]);
  const [total,      setTotal]     = useState(0);
  const [loading,    setLoading]   = useState(true);
  const [search,     setSearch]    = useState('');
  const [statusF,    setStatusF]   = useState('');
  const [priorityF,  setPriorityF] = useState('');
  const [listF,      setListF]     = useState('');
  const [page,       setPage]      = useState(1);
  const [editLead,     setEditLead]    = useState(null);
  const [showAdd,      setShowAdd]     = useState(false);
  const [assignLead,   setAssignLead]  = useState(null);
  const [reassignLead, setReassignLead]= useState(null);
  const [detailLead,   setDetailLead] = useState(null);
  const [selected,     setSelected]   = useState([]);
  const PER = 20;
  const loadingRef = useRef(false);

  const load = async (pg=1) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    try {
      const endpoint = tab === 'assigned' ? '/leads/assigned' : '/leads/saved';
      const params   = { page:pg, limit:PER };
      if (search)    params.search   = search;
      if (statusF)   params.status   = statusF;
      if (priorityF) params.priority = priorityF;
      if (tab === 'saved' && listF) params.list = listF;
      const r = await api.get(endpoint, { params });
      setLeads(r.data.leads||[]);
      setTotal(r.data.total||0);
      setPage(pg);
    } catch { toast.error('Failed to load leads'); }
    finally { setLoading(false); loadingRef.current = false; }
  };

  useEffect(() => { load(1); }, [tab, statusF, priorityF, listF]); // eslint-disable-line

  const updateLead = async (id, data) => {
    const body = {};
    if (data.status !== undefined)      body.status      = data.status;
    if (data.priority !== undefined)    body.priority    = data.priority;
    if (data.notes !== undefined)       body.notes       = data.notes;
    if (data.listName !== undefined)    body.listName    = data.listName;
    if (data.followUpDate)              body.followUpDate= data.followUpDate;
    await api.put(`/leads/saved/${id}`, body);
    toast.success('Lead updated'); load(page);
  };
  const deleteLead = async (id) => {
    if (!window.confirm('Remove this lead?')) return;
    await api.delete(`/leads/saved/${id}`); toast.success('Removed'); load(page);
  };
  const deleteSelected = async () => {
    if (!window.confirm(`Delete ${selected.length} leads?`)) return;
    await Promise.all(selected.map(id => api.delete(`/leads/saved/${id}`).catch(()=>{})));
    setSelected([]); toast.success(`${selected.length} leads removed`); load(1);
  };
  const exportCSV = () => {
    const rows = selected.length>0 ? leads.filter(l=>selected.includes(l.id)) : leads;
    const cols = ['name','business_type','address','phone','email','website','rating','lead_score','status','priority','list_name','notes'];
    const csv  = [cols.join(','), ...rows.map(l=>cols.map(c=>`"${(l[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
    const a = document.createElement('a'); a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'})); a.download='saved_leads.csv'; a.click();
    toast.success(`Exported ${rows.length} leads`);
  };
  const toggleSel   = id => setSelected(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);
  const totalPages  = Math.ceil(total/PER);
  const lists       = [...new Set(leads.map(l=>l.list_name).filter(Boolean))];

  return (
    <div style={{ maxWidth:1300, margin:'0 auto', padding:'24px' }}>

      {/* Header */}
      <div className="flex-between mb-20">
        <div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:800, marginBottom:4 }}>Saved Leads</h1>
          <p style={{ color:'var(--text3)', fontSize:14 }}>{total.toLocaleString()} leads</p>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {tab==='saved' && selected.length>0 && (
            <button className="btn btn-danger btn-sm" onClick={deleteSelected}><Trash2 size={13}/> Delete ({selected.length})</button>
          )}
          {tab==='saved' && (
            <>
              <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead</button>
              {/* <button className="btn btn-success btn-sm" onClick={exportCSV}><Download size={13}/> Export {selected.length>0?`(${selected.length})`:'CSV'}</button> */}
            </>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:4, marginBottom:16, borderBottom:'2px solid var(--border)', paddingBottom:0 }}>
        {[
          { id:'saved',    label:'My Saved Leads', icon:<Bookmark size={14}/> },
          { id:'assigned', label:'Assigned to Me',  icon:<UserCheck size={14}/> },
        ].map(t=>(
          <button key={t.id} onClick={()=>{setTab(t.id);setStatusF('');setPriorityF('');setSelected([]);}}
            style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 16px', borderRadius:'8px 8px 0 0',
              border:'none', cursor:'pointer', fontSize:13.5, fontWeight:tab===t.id?700:500,
              background:tab===t.id?'var(--surface)':'transparent',
              color:tab===t.id?'var(--accent)':'var(--text3)',
              borderBottom:tab===t.id?'2px solid var(--accent)':'2px solid transparent',
              marginBottom:-2 }}>
            {t.icon}{t.label}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="toolbar mb-16">
        <div className="toolbar-left">
          <div className="input-group" style={{minWidth:220}}>
            <Search size={14} className="input-icon"/>
            <input className="input" placeholder={tab==='saved'?'Search saved leads…':'Search assigned leads…'} value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load(1)}/>
          </div>
          <select className="select" style={{width:140}} value={statusF} onChange={e=>setStatusF(e.target.value)}>
            <option value="">All Statuses</option>
            {(tab==='assigned' ? [
              {value:'pending',label:'Pending'},{value:'in_progress',label:'In Progress'},
              {value:'contacted',label:'Contacted'},{value:'converted',label:'Converted'},{value:'lost',label:'Lost'}
            ] : STATUS_OPTS.map(s=>({value:s,label:s.charAt(0).toUpperCase()+s.slice(1)}))).map(s=>(
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </select>
          <select className="select" style={{width:130}} value={priorityF} onChange={e=>setPriorityF(e.target.value)}>
            <option value="">All Priorities</option>
            {PRIORITY_OPTS.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
          </select>
          {tab==='saved' && lists.length>0 && (
            <select className="select" style={{width:150}} value={listF} onChange={e=>setListF(e.target.value)}>
              <option value="">All Lists</option>
              {lists.map(l=><option key={l} value={l}>{l}</option>)}
            </select>
          )}
        </div>
        {tab==='saved' && (
          <div className="toolbar-right">
            <button className="btn btn-ghost btn-sm" onClick={()=>leads.length===selected.length?setSelected([]):setSelected(leads.map(l=>l.id))}>
              {leads.length===selected.length?'Deselect All':'Select All'}
            </button>
          </div>
        )}
      </div>

      {/* Status Summary */}
      <div className="grid-stats mb-16">
        {(tab==='assigned' ? [
          { value:'pending',     label:'Pending',     cls:'badge-gray'   },
          { value:'in_progress', label:'In Progress', cls:'badge-blue'   },
          { value:'contacted',   label:'Contacted',   cls:'badge-gold'   },
          { value:'converted',   label:'Converted',   cls:'badge-green'  },
          { value:'lost',        label:'Lost',        cls:'badge-red'    },
        ] : STATUS_OPTS.map(s=>({ value:s, label:s.charAt(0).toUpperCase()+s.slice(1), cls:STATUS_COLORS[s] }))
        ).map(s => {
          const count = leads.filter(l=>l.status===s.value).length;
          return (
            <div key={s.value} className="card card-sm" style={{ cursor:'pointer', border:statusF===s.value?'2px solid var(--accent)':'1px solid var(--border)' }}
              onClick={()=>setStatusF(statusF===s.value?'':s.value)}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span className={`badge ${s.cls}`}><span className="badge-dot"/>{s.label}</span>
                <span style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:800 }}>{count}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Table — saved tab only */}
      {loading ? (
        <div className="empty-state"><div className="spinner spinner-lg"/></div>
      ) : leads.length===0 ? (
        <div className="empty-state">
          <div className="empty-icon">{tab==='assigned'?<UserCheck size={26}/>:<Bookmark size={26}/>}</div>
          <div className="empty-title">{tab==='assigned'?'No leads assigned to you':'No saved leads yet'}</div>
          <div className="empty-sub">
            {tab==='assigned'
              ? 'When a team member assigns a lead to you, it will appear here.'
              : 'Search for businesses and save the ones you want to follow up with.'}
          </div>
          {tab==='saved' && <button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={13}/> Add Lead Manually</button>}
        </div>

      ) : tab==='saved' ? (
        <>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th><input type="checkbox" className="table-checkbox" checked={selected.length===leads.length&&leads.length>0} onChange={e=>e.target.checked?setSelected(leads.map(l=>l.id)):setSelected([])}/></th>
                  <th>Business</th>
                  <th>Type</th>
                  <th>Contact</th>
                  <th>Rating</th>
                  <th>Score</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>List / Assigned</th>
                  <th>Follow-up</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {leads.map(lead=>(
                  <LeadRow key={lead.id} lead={lead} isAssigned={false}
                    onEdit={setEditLead} onDelete={deleteLead}
                    onAssign={setAssignLead} onReassign={setReassignLead}
                    onDetail={setDetailLead}
                    toggleSel={toggleSel} selected={selected}/>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages>1 && (
            <div className="pagination mt-16">
              <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
              <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
              <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
            </div>
          )}
        </>

      ) : (
        /* ── Assigned tab — same table UI as My Saved Leads ── */
        <>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Business</th>
                  <th>Type</th>
                  <th>Contact</th>
                  <th>Rating</th>
                  <th>Score</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Assigned By</th>
                  <th>Follow-up</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {leads.map(lead=>(
                  <LeadRow key={lead.assignment_id||lead.id} lead={lead} isAssigned={true}
                    onEdit={setEditLead} onDelete={()=>{}}
                    onAssign={setAssignLead} onReassign={setReassignLead}
                    onDetail={setDetailLead}
                    toggleSel={()=>{}} selected={[]}/>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages>1 && (
            <div className="pagination mt-16">
              <button className="page-btn" onClick={()=>load(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
              <span style={{ fontSize:13, color:'var(--text2)' }}>Page {page} of {totalPages}</span>
              <button className="page-btn" onClick={()=>load(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
            </div>
          )}
        </>
      )}

      {editLead    && <EditModal lead={editLead} onClose={()=>setEditLead(null)} onSave={updateLead}/>}
      {showAdd     && <AddLeadModal onClose={()=>setShowAdd(false)} onAdded={()=>load(1)}/>}
      {assignLead  && <AssignModal lead={assignLead} onClose={()=>setAssignLead(null)} onDone={()=>load(page)}/>}
      {reassignLead && <ReassignModal lead={reassignLead} onClose={()=>setReassignLead(null)} onDone={()=>load(page)}/>}
      {detailLead  && <LeadPanel lead={detailLead} isAssigned={tab==='assigned'} onClose={()=>setDetailLead(null)} onRefresh={()=>load(page)}/>}
    </div>
  );
}